// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/bundle.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CommerceData, CommerceDataJson } from "./commerce_pb";
import { file_bundles_v1_commerce } from "./commerce_pb";
import type { GeoLocation, GeoLocationJson, Image, ImageJson, Point, PointJson } from "./common_pb";
import { file_bundles_v1_common } from "./common_pb";
import type { ContactData, ContactDataJson } from "./contact_pb";
import { file_bundles_v1_contact } from "./contact_pb";
import type { FormData, FormDataJson } from "./form_pb";
import { file_bundles_v1_form } from "./form_pb";
import type { RealEstateData, RealEstateDataJson } from "./real_estate_pb";
import { file_bundles_v1_real_estate } from "./real_estate_pb";
import type { Action, ActionJson, Condition, ConditionJson, DeviceType, DeviceTypeJson } from "./rules_pb";
import { file_bundles_v1_rules } from "./rules_pb";
import type { Code, CodeJson } from "../../codes/v2/code_pb";
import { file_codes_v2_code } from "../../codes/v2/code_pb";
import type { Batch, BatchJson, Code as Code$1, CodeJson as CodeJson$1 } from "../../codes/v3/codes_pb";
import { file_codes_v3_codes } from "../../codes/v3/codes_pb";
import type { Creator, CreatorJson, DataType, DataTypeJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { EntrypointBatch, EntrypointBatchJson } from "../../entrypoints/v1/entrypoints_pb";
import { file_entrypoints_v1_entrypoints } from "../../entrypoints/v1/entrypoints_pb";
import type { StructJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Policy, PolicyJson } from "../../legal/v1/legal_pb";
import { file_legal_v1_legal } from "../../legal/v1/legal_pb";
import type { Page, PageJson } from "../../pages/v1/page_pb";
import { file_pages_v1_page } from "../../pages/v1/page_pb";
import type { Page as Page$1, PageJson as PageJson$1 } from "../../pages/v2/page_pb";
import { file_pages_v2_page } from "../../pages/v2/page_pb";
import type { ShortUrl, ShortUrlJson } from "../../shorturls/v1/shorturls_pb";
import { file_shorturls_v1_shorturls } from "../../shorturls/v1/shorturls_pb";
import type { StaticAsset, StaticAssetJson } from "../../staticassets/v1/static_assets_pb";
import { file_staticassets_v1_static_assets } from "../../staticassets/v1/static_assets_pb";
import type { WalletPass, WalletPassBatch, WalletPassBatchJson, WalletPassJson } from "../../walletpasses/v1/walletpasses_pb";
import { file_walletpasses_v1_walletpasses } from "../../walletpasses/v1/walletpasses_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/bundle.proto.
 */
export const file_bundles_v1_bundle: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[
			file_bundles_v1_commerce,
			file_bundles_v1_common,
			file_bundles_v1_contact,
			file_bundles_v1_form,
			file_bundles_v1_real_estate,
			file_bundles_v1_rules,
			file_codes_v2_code,
			file_codes_v3_codes,
			file_common_v1_types,
			file_entrypoints_v1_entrypoints,
			file_google_protobuf_struct,
			file_google_protobuf_timestamp,
			file_legal_v1_legal,
			file_pages_v1_page,
			file_pages_v2_page,
			file_shorturls_v1_shorturls,
			file_staticassets_v1_static_assets,
			file_walletpasses_v1_walletpasses,
		],
	);

/**
 * TemplateRef defines a template to an asset which can be used to instantiate an asset in a suite.
 *
 * @generated from message bundles.v1.TemplateRef
 */
export type TemplateRef = Message<"bundles.v1.TemplateRef"> & {
	/**
	 * Asset Type will define the structure for the default config and how the TemplateRef should be interpreted.
	 *
	 * @generated from field: bundles.v1.AssetType type = 1;
	 */
	type: AssetType;

	/**
	 * A unique ID to the template.
	 *
	 * @generated from field: string template_id = 2;
	 */
	templateId: string;

	/**
	 * The version of the template to use
	 *
	 * @generated from field: string template_version = 11;
	 */
	templateVersion: string;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3;
	 */
	conversionType: ConversionType;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 8;
	 */
	conversionComponent: string;

	/**
	 * Default Config contains the default configuration for this asset type. It is dependent on the asset type, and is merged in an asset ref with any overrides.
	 *
	 * @generated from field: google.protobuf.Struct default_config = 4;
	 */
	defaultConfig?: JsonObject | undefined;

	/**
	 * Initially Disabled is a boolean to determine whether this template should appear disabled in the UI when creating the asset.
	 *
	 * @generated from field: bool initially_disabled = 5;
	 */
	initiallyDisabled: boolean;

	/**
	 * A display name for the template used in editors
	 *
	 * @generated from field: string display_name = 6;
	 */
	displayName: string;

	/**
	 * An optional description to describe template in editors
	 *
	 * @generated from field: optional string description = 13;
	 */
	description?: string | undefined;

	/**
	 * The default text rendered as the name for this template in the conversion flow, i.e. the button text to display the asset.
	 *
	 * @generated from field: string short_name = 7;
	 */
	shortName: string;

	/**
	 * Icon URL can be set to be displayed with the short name when rendering this template in the conversion flow, i.e. the button icon to display the asset.
	 *
	 * @generated from field: string icon_url = 9;
	 */
	iconUrl: string;

	/**
	 * Position is a set of x, y coordinates for where this template should be rendered relative to other templates in a flow editor.
	 *
	 * @generated from field: bundles.v1.Point position = 10;
	 */
	position?: Point | undefined;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 12;
	 */
	renderMode: RenderMode;

	/**
	 * Presentation Mode is how this page is presented in the flow, either as a full page or a slide-up tray. Copied to the AssetRef on create.
	 *
	 * @generated from field: bundles.v1.PresentationMode presentation_mode = 14;
	 */
	presentationMode: PresentationMode;
};

/**
 * TemplateRef defines a template to an asset which can be used to instantiate an asset in a suite.
 *
 * @generated from message bundles.v1.TemplateRef
 */
export type TemplateRefJson = {
	/**
	 * Asset Type will define the structure for the default config and how the TemplateRef should be interpreted.
	 *
	 * @generated from field: bundles.v1.AssetType type = 1;
	 */
	type?: AssetTypeJson;

	/**
	 * A unique ID to the template.
	 *
	 * @generated from field: string template_id = 2;
	 */
	templateId?: string;

	/**
	 * The version of the template to use
	 *
	 * @generated from field: string template_version = 11;
	 */
	templateVersion?: string;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 8;
	 */
	conversionComponent?: string;

	/**
	 * Default Config contains the default configuration for this asset type. It is dependent on the asset type, and is merged in an asset ref with any overrides.
	 *
	 * @generated from field: google.protobuf.Struct default_config = 4;
	 */
	defaultConfig?: StructJson;

	/**
	 * Initially Disabled is a boolean to determine whether this template should appear disabled in the UI when creating the asset.
	 *
	 * @generated from field: bool initially_disabled = 5;
	 */
	initiallyDisabled?: boolean;

	/**
	 * A display name for the template used in editors
	 *
	 * @generated from field: string display_name = 6;
	 */
	displayName?: string;

	/**
	 * An optional description to describe template in editors
	 *
	 * @generated from field: optional string description = 13;
	 */
	description?: string;

	/**
	 * The default text rendered as the name for this template in the conversion flow, i.e. the button text to display the asset.
	 *
	 * @generated from field: string short_name = 7;
	 */
	shortName?: string;

	/**
	 * Icon URL can be set to be displayed with the short name when rendering this template in the conversion flow, i.e. the button icon to display the asset.
	 *
	 * @generated from field: string icon_url = 9;
	 */
	iconUrl?: string;

	/**
	 * Position is a set of x, y coordinates for where this template should be rendered relative to other templates in a flow editor.
	 *
	 * @generated from field: bundles.v1.Point position = 10;
	 */
	position?: PointJson;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 12;
	 */
	renderMode?: RenderModeJson;

	/**
	 * Presentation Mode is how this page is presented in the flow, either as a full page or a slide-up tray. Copied to the AssetRef on create.
	 *
	 * @generated from field: bundles.v1.PresentationMode presentation_mode = 14;
	 */
	presentationMode?: PresentationModeJson;
};

/**
 * Describes the message bundles.v1.TemplateRef.
 * Use `create(TemplateRefSchema)` to create a new message.
 */
export const TemplateRefSchema: GenMessage<TemplateRef, { jsonType: TemplateRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 0);

/**
 * Link is a key structure that defines how templates are connected in bundles. It is the primary mechanism for defining navigation between templates and their corresponding assets.
 *
 * @generated from message bundles.v1.Link
 */
export type Link = Message<"bundles.v1.Link"> & {
	/**
	 * Source is the key in the parent element's map (i.e. a Bundle's Templates field) specifying which element defines the start of the link.
	 *
	 * @generated from field: string source = 1;
	 */
	source: string;

	/**
	 * Destination is the key in the parent element's map (i.e. a Bundle's Templates field) specifying which element defines the end of the link.
	 *
	 * @generated from field: string destination = 2;
	 */
	destination: string;

	/**
	 * Source Anchor is an arbitrary string defining where to draw the source link in a flow editor
	 *
	 * @generated from field: string source_anchor = 5;
	 */
	sourceAnchor: string;

	/**
	 * Destination Anchor is an arbitrary string defining where to draw the destination link in a flow editor
	 *
	 * @generated from field: string destination_anchor = 6;
	 */
	destinationAnchor: string;

	/**
	 * Conditions define the rules of when the source and destination link is allowed to be followed, i.e. a smart rule for location or device.
	 *
	 * @generated from field: repeated bundles.v1.Condition conditions = 3;
	 */
	conditions: Condition[];

	/**
	 * Actions define a set of events which can be triggered when a link is followed. This occurs after conditions are processed.
	 *
	 * @generated from field: repeated bundles.v1.Action actions = 4;
	 */
	actions: Action[];
};

/**
 * Link is a key structure that defines how templates are connected in bundles. It is the primary mechanism for defining navigation between templates and their corresponding assets.
 *
 * @generated from message bundles.v1.Link
 */
export type LinkJson = {
	/**
	 * Source is the key in the parent element's map (i.e. a Bundle's Templates field) specifying which element defines the start of the link.
	 *
	 * @generated from field: string source = 1;
	 */
	source?: string;

	/**
	 * Destination is the key in the parent element's map (i.e. a Bundle's Templates field) specifying which element defines the end of the link.
	 *
	 * @generated from field: string destination = 2;
	 */
	destination?: string;

	/**
	 * Source Anchor is an arbitrary string defining where to draw the source link in a flow editor
	 *
	 * @generated from field: string source_anchor = 5;
	 */
	sourceAnchor?: string;

	/**
	 * Destination Anchor is an arbitrary string defining where to draw the destination link in a flow editor
	 *
	 * @generated from field: string destination_anchor = 6;
	 */
	destinationAnchor?: string;

	/**
	 * Conditions define the rules of when the source and destination link is allowed to be followed, i.e. a smart rule for location or device.
	 *
	 * @generated from field: repeated bundles.v1.Condition conditions = 3;
	 */
	conditions?: ConditionJson[];

	/**
	 * Actions define a set of events which can be triggered when a link is followed. This occurs after conditions are processed.
	 *
	 * @generated from field: repeated bundles.v1.Action actions = 4;
	 */
	actions?: ActionJson[];
};

/**
 * Describes the message bundles.v1.Link.
 * Use `create(LinkSchema)` to create a new message.
 */
export const LinkSchema: GenMessage<Link, { jsonType: LinkJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 1);

/**
 * AssetRef is an instantiation of a TemplateRef in a Suite.
 *
 * @generated from message bundles.v1.AssetRef
 */
export type AssetRef = Message<"bundles.v1.AssetRef"> & {
	/**
	 * Type is the type of Asset, usually defined from the associated template reference.
	 *
	 * @generated from field: bundles.v1.AssetType type = 1;
	 */
	type: AssetType;

	/**
	 * Template ID is the id of the template used to create the Asset
	 *
	 * @generated from field: string template_id = 2;
	 */
	templateId: string;

	/**
	 * The version of the template to use
	 *
	 * @generated from field: string template_version = 12;
	 */
	templateVersion: string;

	/**
	 * Asset ID unique identifier for the asset
	 *
	 * @generated from field: string asset_id = 3;
	 */
	assetId: string;

	/**
	 * The version of the referenced asset
	 *
	 * @generated from field: string asset_version = 14;
	 */
	assetVersion: string;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType: ConversionType;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 10 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent: string;

	/**
	 * Config is dependent on the asset type, and its contents are merged with the template ref's default_config to customize the template.
	 *
	 * @generated from field: google.protobuf.Struct config = 4;
	 */
	config?: JsonObject | undefined;

	/**
	 * Disabled is a boolean to determine whether this asset should be disabled in the UI when rendering the conversion flow.
	 *
	 * @generated from field: bool disabled = 11;
	 */
	disabled: boolean;

	/**
	 * Is Customizable is a boolean as to whether or not one is allowed to override the default config.
	 *
	 * @generated from field: bool is_customizable = 5;
	 */
	isCustomizable: boolean;

	/**
	 * A display name for this asset in editors
	 *
	 * @generated from field: string display_name = 6;
	 */
	displayName: string;

	/**
	 * An optional description to describe asset in editors
	 *
	 * @generated from field: optional string description = 15;
	 */
	description?: string | undefined;

	/**
	 * The default text rendered as the name for this template in the conversion flow, i.e. the button text to display the asset.
	 *
	 * @generated from field: string short_name = 7;
	 */
	shortName: string;

	/**
	 * Icon URL can be set to be displayed with the short name when rendering this template in the conversion flow, i.e. the button icon to display the asset.
	 *
	 * @generated from field: string icon_url = 8;
	 */
	iconUrl: string;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 13;
	 */
	renderMode: RenderMode;

	/**
	 * Presentation Mode is how this page is presented in the flow, either as a full page or a slide-up tray. Copied from the TemplateRef on create.
	 *
	 * @generated from field: bundles.v1.PresentationMode presentation_mode = 17;
	 */
	presentationMode: PresentationMode;

	/**
	 * Position is a set of x, y coordinates for where this template should be rendered relative to other templates in a flow editor.
	 *
	 * @generated from field: bundles.v1.Point position = 16;
	 */
	position?: Point | undefined;
};

/**
 * AssetRef is an instantiation of a TemplateRef in a Suite.
 *
 * @generated from message bundles.v1.AssetRef
 */
export type AssetRefJson = {
	/**
	 * Type is the type of Asset, usually defined from the associated template reference.
	 *
	 * @generated from field: bundles.v1.AssetType type = 1;
	 */
	type?: AssetTypeJson;

	/**
	 * Template ID is the id of the template used to create the Asset
	 *
	 * @generated from field: string template_id = 2;
	 */
	templateId?: string;

	/**
	 * The version of the template to use
	 *
	 * @generated from field: string template_version = 12;
	 */
	templateVersion?: string;

	/**
	 * Asset ID unique identifier for the asset
	 *
	 * @generated from field: string asset_id = 3;
	 */
	assetId?: string;

	/**
	 * The version of the referenced asset
	 *
	 * @generated from field: string asset_version = 14;
	 */
	assetVersion?: string;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 10 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent?: string;

	/**
	 * Config is dependent on the asset type, and its contents are merged with the template ref's default_config to customize the template.
	 *
	 * @generated from field: google.protobuf.Struct config = 4;
	 */
	config?: StructJson;

	/**
	 * Disabled is a boolean to determine whether this asset should be disabled in the UI when rendering the conversion flow.
	 *
	 * @generated from field: bool disabled = 11;
	 */
	disabled?: boolean;

	/**
	 * Is Customizable is a boolean as to whether or not one is allowed to override the default config.
	 *
	 * @generated from field: bool is_customizable = 5;
	 */
	isCustomizable?: boolean;

	/**
	 * A display name for this asset in editors
	 *
	 * @generated from field: string display_name = 6;
	 */
	displayName?: string;

	/**
	 * An optional description to describe asset in editors
	 *
	 * @generated from field: optional string description = 15;
	 */
	description?: string;

	/**
	 * The default text rendered as the name for this template in the conversion flow, i.e. the button text to display the asset.
	 *
	 * @generated from field: string short_name = 7;
	 */
	shortName?: string;

	/**
	 * Icon URL can be set to be displayed with the short name when rendering this template in the conversion flow, i.e. the button icon to display the asset.
	 *
	 * @generated from field: string icon_url = 8;
	 */
	iconUrl?: string;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 13;
	 */
	renderMode?: RenderModeJson;

	/**
	 * Presentation Mode is how this page is presented in the flow, either as a full page or a slide-up tray. Copied from the TemplateRef on create.
	 *
	 * @generated from field: bundles.v1.PresentationMode presentation_mode = 17;
	 */
	presentationMode?: PresentationModeJson;

	/**
	 * Position is a set of x, y coordinates for where this template should be rendered relative to other templates in a flow editor.
	 *
	 * @generated from field: bundles.v1.Point position = 16;
	 */
	position?: PointJson;
};

/**
 * Describes the message bundles.v1.AssetRef.
 * Use `create(AssetRefSchema)` to create a new message.
 */
export const AssetRefSchema: GenMessage<AssetRef, { jsonType: AssetRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 2);

/**
 * Asset is a concrete instantiation of an AssetRef. The Data field type will match the AssetType in the AssetRef that created this Asset.
 *
 * @generated from message bundles.v1.Asset
 */
export type Asset = Message<"bundles.v1.Asset"> & {
	/**
	 * Key will match the AssetRef map on the Suite that created this asset.
	 *
	 * @generated from field: string key = 4;
	 */
	key: string;

	/**
	 * The key that was requested as part of the load, this may be different from the resolved key
	 *
	 * @generated from field: optional string requested_key = 34;
	 */
	requestedKey?: string | undefined;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 15;
	 */
	conversionType: ConversionType;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 16;
	 */
	conversionComponent: string;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 17;
	 */
	renderMode: RenderMode;

	/**
	 * The short name of this asset
	 *
	 * @generated from field: string short_name = 19;
	 */
	shortName: string;

	/**
	 * The display name of this asset
	 *
	 * @generated from field: string display_name = 20;
	 */
	displayName: string;

	/**
	 * The icon URL for this asset
	 *
	 * @generated from field: string icon_url = 21;
	 */
	iconUrl: string;

	/**
	 * The specific underlying asset data
	 *
	 * @generated from oneof bundles.v1.Asset.data
	 */
	data:
		| {
				/**
				 * @generated from field: codes.v2.Code code = 1;
				 */
				value: Code;
				case: "code";
		  }
		| {
				/**
				 * @generated from field: pages.v1.Page page = 2;
				 */
				value: Page;
				case: "page";
		  }
		| {
				/**
				 * @generated from field: pages.v2.Page page_v2 = 3;
				 */
				value: Page$1;
				case: "pageV2";
		  }
		| {
				/**
				 * @generated from field: codes.v3.Code code_v3 = 5;
				 */
				value: Code$1;
				case: "codeV3";
		  }
		| {
				/**
				 * @generated from field: codes.v3.Batch code_batch = 6;
				 */
				value: Batch;
				case: "codeBatch";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.LandingPage landing_page = 7;
				 */
				value: LandingPage;
				case: "landingPage";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.ExternalDestination external_destination = 8;
				 */
				value: ExternalDestination;
				case: "externalDestination";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Experiment experiment = 9;
				 */
				value: Experiment;
				case: "experiment";
		  }
		| {
				/**
				 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 11;
				 */
				value: WalletPass;
				case: "walletPass";
		  }
		| {
				/**
				 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 12;
				 */
				value: WalletPassBatch;
				case: "walletPassBatch";
		  }
		| {
				/**
				 * @generated from field: shorturls.v1.ShortUrl short_url = 13;
				 */
				value: ShortUrl;
				case: "shortUrl";
		  }
		| {
				/**
				 * @generated from field: entrypoints.v1.EntrypointBatch entrypoint_batch = 18;
				 */
				value: EntrypointBatch;
				case: "entrypointBatch";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Module module = 22;
				 */
				value: Module;
				case: "module";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Decision decision = 23;
				 */
				value: Decision;
				case: "decision";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PageContainer page_container = 24;
				 */
				value: PageContainer;
				case: "pageContainer";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Suite suite = 25;
				 */
				value: Suite;
				case: "suite";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.SuiteRef suite_ref = 26;
				 */
				value: SuiteRef;
				case: "suiteRef";
		  }
		| {
				/**
				 * @generated from field: staticassets.v1.StaticAsset static_asset = 27;
				 */
				value: StaticAsset;
				case: "staticAsset";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PolicyRef policy_ref = 28;
				 */
				value: PolicyRef;
				case: "policyRef";
		  }
		| {
				/**
				 * @generated from field: legal.v1.Policy policy = 29;
				 */
				value: Policy;
				case: "policy";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Agent agent = 30;
				 */
				value: Agent;
				case: "agent";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.EntryPointBatchRef entrypoint_batch_ref = 31;
				 */
				value: EntryPointBatchRef;
				case: "entrypointBatchRef";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.StaticAssetRef static_asset_ref = 32;
				 */
				value: StaticAssetRef;
				case: "staticAssetRef";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.ExitConfig exit = 33;
				 */
				value: ExitConfig;
				case: "exit";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Lookup lookup = 35;
				 */
				value: Lookup;
				case: "lookup";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.AdUnitConfig ad_unit_config = 36;
				 */
				value: AdUnitConfig;
				case: "adUnitConfig";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.AdUnit ad_unit = 37;
				 */
				value: AdUnit;
				case: "adUnit";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Goto goto = 38;
				 */
				value: Goto;
				case: "goto";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * An arbitrary data object for passing metadata about how this Asset was created. Currently used for experiment nodes to link bandit data on what to render.
	 *
	 * @generated from field: google.protobuf.Struct context = 10;
	 */
	context?: JsonObject | undefined;
};

/**
 * Asset is a concrete instantiation of an AssetRef. The Data field type will match the AssetType in the AssetRef that created this Asset.
 *
 * @generated from message bundles.v1.Asset
 */
export type AssetJson = {
	/**
	 * Key will match the AssetRef map on the Suite that created this asset.
	 *
	 * @generated from field: string key = 4;
	 */
	key?: string;

	/**
	 * The key that was requested as part of the load, this may be different from the resolved key
	 *
	 * @generated from field: optional string requested_key = 34;
	 */
	requestedKey?: string;

	/**
	 * Conversion Type is an enumeration used to describe the intended purpose of this specific template and eventual asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 15;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * Conversion Component corresponds is the default value for Flow and Event messages that define the key in the data field of the ExecuteResponse message. This identifies the component that triggered the conversion event.
	 *
	 * @generated from field: string conversion_component = 16;
	 */
	conversionComponent?: string;

	/**
	 * The rendering mode to use when rendering this asset in a suite
	 *
	 * @generated from field: bundles.v1.RenderMode render_mode = 17;
	 */
	renderMode?: RenderModeJson;

	/**
	 * The short name of this asset
	 *
	 * @generated from field: string short_name = 19;
	 */
	shortName?: string;

	/**
	 * The display name of this asset
	 *
	 * @generated from field: string display_name = 20;
	 */
	displayName?: string;

	/**
	 * The icon URL for this asset
	 *
	 * @generated from field: string icon_url = 21;
	 */
	iconUrl?: string;

	/**
	 * @generated from field: codes.v2.Code code = 1;
	 */
	code?: CodeJson;

	/**
	 * @generated from field: pages.v1.Page page = 2;
	 */
	page?: PageJson;

	/**
	 * @generated from field: pages.v2.Page page_v2 = 3;
	 */
	pageV2?: PageJson$1;

	/**
	 * @generated from field: codes.v3.Code code_v3 = 5;
	 */
	codeV3?: CodeJson$1;

	/**
	 * @generated from field: codes.v3.Batch code_batch = 6;
	 */
	codeBatch?: BatchJson;

	/**
	 * @generated from field: bundles.v1.LandingPage landing_page = 7;
	 */
	landingPage?: LandingPageJson;

	/**
	 * @generated from field: bundles.v1.ExternalDestination external_destination = 8;
	 */
	externalDestination?: ExternalDestinationJson;

	/**
	 * @generated from field: bundles.v1.Experiment experiment = 9;
	 */
	experiment?: ExperimentJson;

	/**
	 * @generated from field: walletpasses.v1.WalletPass wallet_pass = 11;
	 */
	walletPass?: WalletPassJson;

	/**
	 * @generated from field: walletpasses.v1.WalletPassBatch wallet_pass_batch = 12;
	 */
	walletPassBatch?: WalletPassBatchJson;

	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 13;
	 */
	shortUrl?: ShortUrlJson;

	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch entrypoint_batch = 18;
	 */
	entrypointBatch?: EntrypointBatchJson;

	/**
	 * @generated from field: bundles.v1.Module module = 22;
	 */
	module?: ModuleJson;

	/**
	 * @generated from field: bundles.v1.Decision decision = 23;
	 */
	decision?: DecisionJson;

	/**
	 * @generated from field: bundles.v1.PageContainer page_container = 24;
	 */
	pageContainer?: PageContainerJson;

	/**
	 * @generated from field: bundles.v1.Suite suite = 25;
	 */
	suite?: SuiteJson;

	/**
	 * @generated from field: bundles.v1.SuiteRef suite_ref = 26;
	 */
	suiteRef?: SuiteRefJson;

	/**
	 * @generated from field: staticassets.v1.StaticAsset static_asset = 27;
	 */
	staticAsset?: StaticAssetJson;

	/**
	 * @generated from field: bundles.v1.PolicyRef policy_ref = 28;
	 */
	policyRef?: PolicyRefJson;

	/**
	 * @generated from field: legal.v1.Policy policy = 29;
	 */
	policy?: PolicyJson;

	/**
	 * @generated from field: bundles.v1.Agent agent = 30;
	 */
	agent?: AgentJson;

	/**
	 * @generated from field: bundles.v1.EntryPointBatchRef entrypoint_batch_ref = 31;
	 */
	entrypointBatchRef?: EntryPointBatchRefJson;

	/**
	 * @generated from field: bundles.v1.StaticAssetRef static_asset_ref = 32;
	 */
	staticAssetRef?: StaticAssetRefJson;

	/**
	 * @generated from field: bundles.v1.ExitConfig exit = 33;
	 */
	exit?: ExitConfigJson;

	/**
	 * @generated from field: bundles.v1.Lookup lookup = 35;
	 */
	lookup?: LookupJson;

	/**
	 * @generated from field: bundles.v1.AdUnitConfig ad_unit_config = 36;
	 */
	adUnitConfig?: AdUnitConfigJson;

	/**
	 * @generated from field: bundles.v1.AdUnit ad_unit = 37;
	 */
	adUnit?: AdUnitJson;

	/**
	 * @generated from field: bundles.v1.Goto goto = 38;
	 */
	goto?: GotoJson;

	/**
	 * An arbitrary data object for passing metadata about how this Asset was created. Currently used for experiment nodes to link bandit data on what to render.
	 *
	 * @generated from field: google.protobuf.Struct context = 10;
	 */
	context?: StructJson;
};

/**
 * Describes the message bundles.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset, { jsonType: AssetJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 3);

/**
 * @generated from message bundles.v1.ExitConfig
 */
export type ExitConfig = Message<"bundles.v1.ExitConfig"> & {};

/**
 * @generated from message bundles.v1.ExitConfig
 */
export type ExitConfigJson = {};

/**
 * Describes the message bundles.v1.ExitConfig.
 * Use `create(ExitConfigSchema)` to create a new message.
 */
export const ExitConfigSchema: GenMessage<ExitConfig, { jsonType: ExitConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 4);

/**
 * @generated from message bundles.v1.Decision
 */
export type Decision = Message<"bundles.v1.Decision"> & {};

/**
 * @generated from message bundles.v1.Decision
 */
export type DecisionJson = {};

/**
 * Describes the message bundles.v1.Decision.
 * Use `create(DecisionSchema)` to create a new message.
 */
export const DecisionSchema: GenMessage<Decision, { jsonType: DecisionJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 5);

/**
 * LandingPage is an asset type for the initial display of a post-scan experience. It should always be the first link after a scan, unless you want to scan directly to an ExternalDestination.
 *
 * @generated from message bundles.v1.LandingPage
 */
export type LandingPage = Message<"bundles.v1.LandingPage"> & {
	/**
	 * The layout to use
	 *
	 * @generated from field: string layout_name = 7;
	 */
	layoutName: string;

	/**
	 * The theme to use
	 *
	 * @generated from field: string theme = 10;
	 */
	theme: string;

	/**
	 * Primary Text is the title or lede when rendering the landing page.
	 *
	 * @generated from field: string primary_text = 1;
	 */
	primaryText: string;

	/**
	 * Secondary Text is the optional secondary text to render underneath the primary.
	 *
	 * @generated from field: bundles.v1.DetailItem secondary_text = 2;
	 */
	secondaryText?: DetailItem | undefined;

	/**
	 * Tertiary Text A set of detail information to present on the landing page.
	 *
	 * @generated from field: repeated bundles.v1.DetailItem tertiary_text = 3;
	 */
	tertiaryText: DetailItem[];

	/**
	 * Supporting Text is the optional supporting text to render underneath the tertiary text.
	 *
	 * @generated from field: optional string supporting_text = 8;
	 */
	supportingText?: string | undefined;

	/**
	 * Highlight text is used to draw attention to a specific detail item.
	 *
	 * @generated from field: optional bundles.v1.DetailItem highlight_text = 9;
	 */
	highlightText?: DetailItem | undefined;

	/**
	 * Images is a set of images to present on the landing page.
	 *
	 * @generated from field: repeated bundles.v1.Image images = 4;
	 */
	images: Image[];

	/**
	 * The interpolation key to use to render the images
	 *
	 * @generated from field: optional string images_key = 12;
	 */
	imagesKey?: string | undefined;

	/**
	 * CTA Text is the call to action text of the primary button on the page to display the conversion. Triggering the CTA should generate a View event.
	 *
	 * @generated from field: string cta_text = 5;
	 */
	ctaText: string;

	/**
	 * The number of modules to display on the landing page before adding a 'View More' button. If not set, all modules will be displayed.
	 *
	 * @generated from field: optional int32 max_visible_modules = 6;
	 */
	maxVisibleModules?: number | undefined;

	/**
	 * The set of theme overrides to apply to the landing page
	 *
	 * @generated from field: optional google.protobuf.Struct theme_overrides = 11;
	 */
	themeOverrides?: JsonObject | undefined;
};

/**
 * LandingPage is an asset type for the initial display of a post-scan experience. It should always be the first link after a scan, unless you want to scan directly to an ExternalDestination.
 *
 * @generated from message bundles.v1.LandingPage
 */
export type LandingPageJson = {
	/**
	 * The layout to use
	 *
	 * @generated from field: string layout_name = 7;
	 */
	layoutName?: string;

	/**
	 * The theme to use
	 *
	 * @generated from field: string theme = 10;
	 */
	theme?: string;

	/**
	 * Primary Text is the title or lede when rendering the landing page.
	 *
	 * @generated from field: string primary_text = 1;
	 */
	primaryText?: string;

	/**
	 * Secondary Text is the optional secondary text to render underneath the primary.
	 *
	 * @generated from field: bundles.v1.DetailItem secondary_text = 2;
	 */
	secondaryText?: DetailItemJson;

	/**
	 * Tertiary Text A set of detail information to present on the landing page.
	 *
	 * @generated from field: repeated bundles.v1.DetailItem tertiary_text = 3;
	 */
	tertiaryText?: DetailItemJson[];

	/**
	 * Supporting Text is the optional supporting text to render underneath the tertiary text.
	 *
	 * @generated from field: optional string supporting_text = 8;
	 */
	supportingText?: string;

	/**
	 * Highlight text is used to draw attention to a specific detail item.
	 *
	 * @generated from field: optional bundles.v1.DetailItem highlight_text = 9;
	 */
	highlightText?: DetailItemJson;

	/**
	 * Images is a set of images to present on the landing page.
	 *
	 * @generated from field: repeated bundles.v1.Image images = 4;
	 */
	images?: ImageJson[];

	/**
	 * The interpolation key to use to render the images
	 *
	 * @generated from field: optional string images_key = 12;
	 */
	imagesKey?: string;

	/**
	 * CTA Text is the call to action text of the primary button on the page to display the conversion. Triggering the CTA should generate a View event.
	 *
	 * @generated from field: string cta_text = 5;
	 */
	ctaText?: string;

	/**
	 * The number of modules to display on the landing page before adding a 'View More' button. If not set, all modules will be displayed.
	 *
	 * @generated from field: optional int32 max_visible_modules = 6;
	 */
	maxVisibleModules?: number;

	/**
	 * The set of theme overrides to apply to the landing page
	 *
	 * @generated from field: optional google.protobuf.Struct theme_overrides = 11;
	 */
	themeOverrides?: StructJson;
};

/**
 * Describes the message bundles.v1.LandingPage.
 * Use `create(LandingPageSchema)` to create a new message.
 */
export const LandingPageSchema: GenMessage<LandingPage, { jsonType: LandingPageJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 6);

/**
 * PageContainer is an asset type for a composable page.
 *
 * @generated from message bundles.v1.PageContainer
 */
export type PageContainer = Message<"bundles.v1.PageContainer"> & {
	/**
	 * The layout to use
	 *
	 * @generated from field: string layout_name = 1;
	 */
	layoutName: string;

	/**
	 * The theme to use
	 *
	 * @generated from field: string theme = 2;
	 */
	theme: string;

	/**
	 * The set of theme overrides to apply to the landing page
	 *
	 * @generated from field: optional google.protobuf.Struct theme_overrides = 3;
	 */
	themeOverrides?: JsonObject | undefined;
};

/**
 * PageContainer is an asset type for a composable page.
 *
 * @generated from message bundles.v1.PageContainer
 */
export type PageContainerJson = {
	/**
	 * The layout to use
	 *
	 * @generated from field: string layout_name = 1;
	 */
	layoutName?: string;

	/**
	 * The theme to use
	 *
	 * @generated from field: string theme = 2;
	 */
	theme?: string;

	/**
	 * The set of theme overrides to apply to the landing page
	 *
	 * @generated from field: optional google.protobuf.Struct theme_overrides = 3;
	 */
	themeOverrides?: StructJson;
};

/**
 * Describes the message bundles.v1.PageContainer.
 * Use `create(PageContainerSchema)` to create a new message.
 */
export const PageContainerSchema: GenMessage<PageContainer, { jsonType: PageContainerJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 7);

/**
 * DetailItem is a structure for displaying details on the landing page like number of bedrooms in a real estate listing.
 *
 * @generated from message bundles.v1.DetailItem
 */
export type DetailItem = Message<"bundles.v1.DetailItem"> & {
	/**
	 * Text is the text to display
	 *
	 * @generated from field: string text = 1;
	 */
	text: string;

	/**
	 * Icon is the name of the icon in the hero icon library to display next to the text..
	 *
	 * @generated from field: optional string icon = 2;
	 */
	icon?: string | undefined;

	/**
	 * The icon set the specified icon is a part of
	 *
	 * @generated from field: optional string icon_set = 4;
	 */
	iconSet?: string | undefined;

	/**
	 * Color Hex is the text and icon should be rendered in hex notation.
	 *
	 * @generated from field: optional string color_hex = 3;
	 */
	colorHex?: string | undefined;
};

/**
 * DetailItem is a structure for displaying details on the landing page like number of bedrooms in a real estate listing.
 *
 * @generated from message bundles.v1.DetailItem
 */
export type DetailItemJson = {
	/**
	 * Text is the text to display
	 *
	 * @generated from field: string text = 1;
	 */
	text?: string;

	/**
	 * Icon is the name of the icon in the hero icon library to display next to the text..
	 *
	 * @generated from field: optional string icon = 2;
	 */
	icon?: string;

	/**
	 * The icon set the specified icon is a part of
	 *
	 * @generated from field: optional string icon_set = 4;
	 */
	iconSet?: string;

	/**
	 * Color Hex is the text and icon should be rendered in hex notation.
	 *
	 * @generated from field: optional string color_hex = 3;
	 */
	colorHex?: string;
};

/**
 * Describes the message bundles.v1.DetailItem.
 * Use `create(DetailItemSchema)` to create a new message.
 */
export const DetailItemSchema: GenMessage<DetailItem, { jsonType: DetailItemJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 8);

/**
 * UTM Parameters allow utms to be associated with an external destination. These values may be tokenized to be filled in with
 * attributes from the request context.
 *
 * @generated from message bundles.v1.UtmParameters
 */
export type UtmParameters = Message<"bundles.v1.UtmParameters"> & {
	/**
	 * @generated from field: string utm_source = 1;
	 */
	utmSource: string;

	/**
	 * @generated from field: string utm_medium = 2;
	 */
	utmMedium: string;

	/**
	 * @generated from field: string utm_campaign = 3;
	 */
	utmCampaign: string;

	/**
	 * @generated from field: string utm_term = 4;
	 */
	utmTerm: string;

	/**
	 * @generated from field: string utm_content = 5;
	 */
	utmContent: string;
};

/**
 * UTM Parameters allow utms to be associated with an external destination. These values may be tokenized to be filled in with
 * attributes from the request context.
 *
 * @generated from message bundles.v1.UtmParameters
 */
export type UtmParametersJson = {
	/**
	 * @generated from field: string utm_source = 1;
	 */
	utmSource?: string;

	/**
	 * @generated from field: string utm_medium = 2;
	 */
	utmMedium?: string;

	/**
	 * @generated from field: string utm_campaign = 3;
	 */
	utmCampaign?: string;

	/**
	 * @generated from field: string utm_term = 4;
	 */
	utmTerm?: string;

	/**
	 * @generated from field: string utm_content = 5;
	 */
	utmContent?: string;
};

/**
 * Describes the message bundles.v1.UtmParameters.
 * Use `create(UtmParametersSchema)` to create a new message.
 */
export const UtmParametersSchema: GenMessage<UtmParameters, { jsonType: UtmParametersJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 9);

/**
 * @generated from message bundles.v1.ExternalDestination
 */
export type ExternalDestination = Message<"bundles.v1.ExternalDestination"> & {
	/**
	 * @generated from field: bundles.v1.ExternalDestinationType type = 8;
	 */
	type: ExternalDestinationType;

	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: string resolved_url = 5;
	 */
	resolvedUrl: string;

	/**
	 * @generated from field: string app_fallback_url = 9;
	 */
	appFallbackUrl: string;

	/**
	 * @generated from field: map<string, string> query_params = 2;
	 */
	queryParams: { [key: string]: string };

	/**
	 * @generated from field: bool append_utm_parameters = 4;
	 */
	appendUtmParameters: boolean;

	/**
	 * @generated from field: bundles.v1.UtmParameters utm_parameters = 3;
	 */
	utmParameters?: UtmParameters | undefined;

	/**
	 * @generated from field: bool append_pixel_parameter = 6;
	 */
	appendPixelParameter: boolean;

	/**
	 * @generated from field: google.protobuf.Struct suite_override = 7;
	 */
	suiteOverride?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.ExternalDestination
 */
export type ExternalDestinationJson = {
	/**
	 * @generated from field: bundles.v1.ExternalDestinationType type = 8;
	 */
	type?: ExternalDestinationTypeJson;

	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: string resolved_url = 5;
	 */
	resolvedUrl?: string;

	/**
	 * @generated from field: string app_fallback_url = 9;
	 */
	appFallbackUrl?: string;

	/**
	 * @generated from field: map<string, string> query_params = 2;
	 */
	queryParams?: { [key: string]: string };

	/**
	 * @generated from field: bool append_utm_parameters = 4;
	 */
	appendUtmParameters?: boolean;

	/**
	 * @generated from field: bundles.v1.UtmParameters utm_parameters = 3;
	 */
	utmParameters?: UtmParametersJson;

	/**
	 * @generated from field: bool append_pixel_parameter = 6;
	 */
	appendPixelParameter?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct suite_override = 7;
	 */
	suiteOverride?: StructJson;
};

/**
 * Describes the message bundles.v1.ExternalDestination.
 * Use `create(ExternalDestinationSchema)` to create a new message.
 */
export const ExternalDestinationSchema: GenMessage<ExternalDestination, { jsonType: ExternalDestinationJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 10);

/**
 * @generated from message bundles.v1.Experiment
 */
export type Experiment = Message<"bundles.v1.Experiment"> & {
	/**
	 * @generated from field: bundles.v1.ExperimentType experiment_type = 1;
	 */
	experimentType: ExperimentType;

	/**
	 * @generated from oneof bundles.v1.Experiment.value
	 */
	value:
		| {
				/**
				 * @generated from field: bundles.v1.BanditExperimentData bandit_experiment_data = 2;
				 */
				value: BanditExperimentData;
				case: "banditExperimentData";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.Experiment
 */
export type ExperimentJson = {
	/**
	 * @generated from field: bundles.v1.ExperimentType experiment_type = 1;
	 */
	experimentType?: ExperimentTypeJson;

	/**
	 * @generated from field: bundles.v1.BanditExperimentData bandit_experiment_data = 2;
	 */
	banditExperimentData?: BanditExperimentDataJson;
};

/**
 * Describes the message bundles.v1.Experiment.
 * Use `create(ExperimentSchema)` to create a new message.
 */
export const ExperimentSchema: GenMessage<Experiment, { jsonType: ExperimentJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 11);

/**
 * @generated from message bundles.v1.BanditExperimentData
 */
export type BanditExperimentData = Message<"bundles.v1.BanditExperimentData"> & {
	/**
	 * @generated from field: string default_asset_key = 1;
	 */
	defaultAssetKey: string;
};

/**
 * @generated from message bundles.v1.BanditExperimentData
 */
export type BanditExperimentDataJson = {
	/**
	 * @generated from field: string default_asset_key = 1;
	 */
	defaultAssetKey?: string;
};

/**
 * Describes the message bundles.v1.BanditExperimentData.
 * Use `create(BanditExperimentDataSchema)` to create a new message.
 */
export const BanditExperimentDataSchema: GenMessage<BanditExperimentData, { jsonType: BanditExperimentDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 12);

/**
 * @generated from message bundles.v1.Lookup
 */
export type Lookup = Message<"bundles.v1.Lookup"> & {
	/**
	 * @generated from oneof bundles.v1.Lookup.config
	 */
	config:
		| {
				/**
				 * @generated from field: bundles.v1.ApiLookup api_lookup = 1;
				 */
				value: ApiLookup;
				case: "apiLookup";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.CsvLookup csv_lookup = 2;
				 */
				value: CsvLookup;
				case: "csvLookup";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.Lookup
 */
export type LookupJson = {
	/**
	 * @generated from field: bundles.v1.ApiLookup api_lookup = 1;
	 */
	apiLookup?: ApiLookupJson;

	/**
	 * @generated from field: bundles.v1.CsvLookup csv_lookup = 2;
	 */
	csvLookup?: CsvLookupJson;
};

/**
 * Describes the message bundles.v1.Lookup.
 * Use `create(LookupSchema)` to create a new message.
 */
export const LookupSchema: GenMessage<Lookup, { jsonType: LookupJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 13);

/**
 * @generated from message bundles.v1.AuthConfig
 */
export type AuthConfig = Message<"bundles.v1.AuthConfig"> & {
	/**
	 * @generated from field: bundles.v1.AuthType type = 1;
	 */
	type: AuthType;

	/**
	 * @generated from oneof bundles.v1.AuthConfig.config
	 */
	config:
		| {
				/**
				 * @generated from field: bundles.v1.BasicAuthConfig basic = 2;
				 */
				value: BasicAuthConfig;
				case: "basic";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.BearerAuthConfig bearer = 3;
				 */
				value: BearerAuthConfig;
				case: "bearer";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.ApiKeyAuthConfig api_key = 4;
				 */
				value: ApiKeyAuthConfig;
				case: "apiKey";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: string secret_id = 5;
	 */
	secretId: string;
};

/**
 * @generated from message bundles.v1.AuthConfig
 */
export type AuthConfigJson = {
	/**
	 * @generated from field: bundles.v1.AuthType type = 1;
	 */
	type?: AuthTypeJson;

	/**
	 * @generated from field: bundles.v1.BasicAuthConfig basic = 2;
	 */
	basic?: BasicAuthConfigJson;

	/**
	 * @generated from field: bundles.v1.BearerAuthConfig bearer = 3;
	 */
	bearer?: BearerAuthConfigJson;

	/**
	 * @generated from field: bundles.v1.ApiKeyAuthConfig api_key = 4;
	 */
	apiKey?: ApiKeyAuthConfigJson;

	/**
	 * @generated from field: string secret_id = 5;
	 */
	secretId?: string;
};

/**
 * Describes the message bundles.v1.AuthConfig.
 * Use `create(AuthConfigSchema)` to create a new message.
 */
export const AuthConfigSchema: GenMessage<AuthConfig, { jsonType: AuthConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 14);

/**
 * @generated from message bundles.v1.BasicAuthConfig
 */
export type BasicAuthConfig = Message<"bundles.v1.BasicAuthConfig"> & {
	/**
	 * @generated from field: string username = 1;
	 */
	username: string;

	/**
	 * @generated from field: string password = 2;
	 */
	password: string;
};

/**
 * @generated from message bundles.v1.BasicAuthConfig
 */
export type BasicAuthConfigJson = {
	/**
	 * @generated from field: string username = 1;
	 */
	username?: string;

	/**
	 * @generated from field: string password = 2;
	 */
	password?: string;
};

/**
 * Describes the message bundles.v1.BasicAuthConfig.
 * Use `create(BasicAuthConfigSchema)` to create a new message.
 */
export const BasicAuthConfigSchema: GenMessage<BasicAuthConfig, { jsonType: BasicAuthConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 15);

/**
 * @generated from message bundles.v1.BearerAuthConfig
 */
export type BearerAuthConfig = Message<"bundles.v1.BearerAuthConfig"> & {
	/**
	 * @generated from field: string token = 1;
	 */
	token: string;
};

/**
 * @generated from message bundles.v1.BearerAuthConfig
 */
export type BearerAuthConfigJson = {
	/**
	 * @generated from field: string token = 1;
	 */
	token?: string;
};

/**
 * Describes the message bundles.v1.BearerAuthConfig.
 * Use `create(BearerAuthConfigSchema)` to create a new message.
 */
export const BearerAuthConfigSchema: GenMessage<BearerAuthConfig, { jsonType: BearerAuthConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 16);

/**
 * @generated from message bundles.v1.ApiKeyAuthConfig
 */
export type ApiKeyAuthConfig = Message<"bundles.v1.ApiKeyAuthConfig"> & {
	/**
	 * @generated from field: string key_name = 1;
	 */
	keyName: string;

	/**
	 * @generated from field: string key_value = 2;
	 */
	keyValue: string;

	/**
	 * @generated from field: bundles.v1.ApiKeyLocation location = 3;
	 */
	location: ApiKeyLocation;
};

/**
 * @generated from message bundles.v1.ApiKeyAuthConfig
 */
export type ApiKeyAuthConfigJson = {
	/**
	 * @generated from field: string key_name = 1;
	 */
	keyName?: string;

	/**
	 * @generated from field: string key_value = 2;
	 */
	keyValue?: string;

	/**
	 * @generated from field: bundles.v1.ApiKeyLocation location = 3;
	 */
	location?: ApiKeyLocationJson;
};

/**
 * Describes the message bundles.v1.ApiKeyAuthConfig.
 * Use `create(ApiKeyAuthConfigSchema)` to create a new message.
 */
export const ApiKeyAuthConfigSchema: GenMessage<ApiKeyAuthConfig, { jsonType: ApiKeyAuthConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 17);

/**
 * @generated from message bundles.v1.ApiLookup
 */
export type ApiLookup = Message<"bundles.v1.ApiLookup"> & {
	/**
	 * @generated from field: bundles.v1.ApiRequest request = 1;
	 */
	request?: ApiRequest | undefined;

	/**
	 * @generated from field: bundles.v1.ApiResponse response = 2;
	 */
	response?: ApiResponse | undefined;
};

/**
 * @generated from message bundles.v1.ApiLookup
 */
export type ApiLookupJson = {
	/**
	 * @generated from field: bundles.v1.ApiRequest request = 1;
	 */
	request?: ApiRequestJson;

	/**
	 * @generated from field: bundles.v1.ApiResponse response = 2;
	 */
	response?: ApiResponseJson;
};

/**
 * Describes the message bundles.v1.ApiLookup.
 * Use `create(ApiLookupSchema)` to create a new message.
 */
export const ApiLookupSchema: GenMessage<ApiLookup, { jsonType: ApiLookupJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 18);

/**
 * @generated from message bundles.v1.Header
 */
export type Header = Message<"bundles.v1.Header"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value: string;
};

/**
 * @generated from message bundles.v1.Header
 */
export type HeaderJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value?: string;
};

/**
 * Describes the message bundles.v1.Header.
 * Use `create(HeaderSchema)` to create a new message.
 */
export const HeaderSchema: GenMessage<Header, { jsonType: HeaderJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 19);

/**
 * @generated from message bundles.v1.Param
 */
export type Param = Message<"bundles.v1.Param"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value: string;
};

/**
 * @generated from message bundles.v1.Param
 */
export type ParamJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value?: string;
};

/**
 * Describes the message bundles.v1.Param.
 * Use `create(ParamSchema)` to create a new message.
 */
export const ParamSchema: GenMessage<Param, { jsonType: ParamJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 20);

/**
 * @generated from message bundles.v1.ApiRequest
 */
export type ApiRequest = Message<"bundles.v1.ApiRequest"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;

	/**
	 * @generated from field: bundles.v1.HttpMethod method = 2;
	 */
	method: HttpMethod;

	/**
	 * @generated from field: repeated bundles.v1.Param query_params = 3;
	 */
	queryParams: Param[];

	/**
	 * @generated from field: repeated bundles.v1.Header headers = 4;
	 */
	headers: Header[];

	/**
	 * @generated from field: optional bundles.v1.AuthConfig auth_config = 5;
	 */
	authConfig?: AuthConfig | undefined;

	/**
	 * @generated from oneof bundles.v1.ApiRequest.body
	 */
	body:
		| {
				/**
				 * @generated from field: string raw = 6;
				 */
				value: string;
				case: "raw";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.FormBody form = 7;
				 */
				value: FormBody;
				case: "form";
		  }
		| {
				/**
				 * @generated from field: google.protobuf.Struct json = 8;
				 */
				value: JsonObject;
				case: "json";
		  }
		| {
				/**
				 * @generated from field: string xml = 9;
				 */
				value: string;
				case: "xml";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.ApiRequest
 */
export type ApiRequestJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;

	/**
	 * @generated from field: bundles.v1.HttpMethod method = 2;
	 */
	method?: HttpMethodJson;

	/**
	 * @generated from field: repeated bundles.v1.Param query_params = 3;
	 */
	queryParams?: ParamJson[];

	/**
	 * @generated from field: repeated bundles.v1.Header headers = 4;
	 */
	headers?: HeaderJson[];

	/**
	 * @generated from field: optional bundles.v1.AuthConfig auth_config = 5;
	 */
	authConfig?: AuthConfigJson;

	/**
	 * @generated from field: string raw = 6;
	 */
	raw?: string;

	/**
	 * @generated from field: bundles.v1.FormBody form = 7;
	 */
	form?: FormBodyJson;

	/**
	 * @generated from field: google.protobuf.Struct json = 8;
	 */
	json?: StructJson;

	/**
	 * @generated from field: string xml = 9;
	 */
	xml?: string;
};

/**
 * Describes the message bundles.v1.ApiRequest.
 * Use `create(ApiRequestSchema)` to create a new message.
 */
export const ApiRequestSchema: GenMessage<ApiRequest, { jsonType: ApiRequestJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 21);

/**
 * @generated from message bundles.v1.FormBody
 */
export type FormBody = Message<"bundles.v1.FormBody"> & {
	/**
	 * @generated from field: repeated bundles.v1.Param form_data = 1;
	 */
	formData: Param[];
};

/**
 * @generated from message bundles.v1.FormBody
 */
export type FormBodyJson = {
	/**
	 * @generated from field: repeated bundles.v1.Param form_data = 1;
	 */
	formData?: ParamJson[];
};

/**
 * Describes the message bundles.v1.FormBody.
 * Use `create(FormBodySchema)` to create a new message.
 */
export const FormBodySchema: GenMessage<FormBody, { jsonType: FormBodyJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 22);

/**
 * @generated from message bundles.v1.ApiResponse
 */
export type ApiResponse = Message<"bundles.v1.ApiResponse"> & {
	/**
	 * @generated from field: repeated int32 succes_status_codes = 1;
	 */
	succesStatusCodes: number[];

	/**
	 * @generated from field: repeated bundles.v1.MappedValue body_mapping = 2;
	 */
	bodyMapping: MappedValue[];
};

/**
 * @generated from message bundles.v1.ApiResponse
 */
export type ApiResponseJson = {
	/**
	 * @generated from field: repeated int32 succes_status_codes = 1;
	 */
	succesStatusCodes?: number[];

	/**
	 * @generated from field: repeated bundles.v1.MappedValue body_mapping = 2;
	 */
	bodyMapping?: MappedValueJson[];
};

/**
 * Describes the message bundles.v1.ApiResponse.
 * Use `create(ApiResponseSchema)` to create a new message.
 */
export const ApiResponseSchema: GenMessage<ApiResponse, { jsonType: ApiResponseJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 23);

/**
 * @generated from message bundles.v1.CsvLookup
 */
export type CsvLookup = Message<"bundles.v1.CsvLookup"> & {
	/**
	 * @generated from field: string csv_url = 1;
	 */
	csvUrl: string;

	/**
	 * @generated from field: string key_column = 2;
	 */
	keyColumn: string;

	/**
	 * @generated from field: repeated bundles.v1.MappedValue column_mapping = 3;
	 */
	columnMapping: MappedValue[];
};

/**
 * @generated from message bundles.v1.CsvLookup
 */
export type CsvLookupJson = {
	/**
	 * @generated from field: string csv_url = 1;
	 */
	csvUrl?: string;

	/**
	 * @generated from field: string key_column = 2;
	 */
	keyColumn?: string;

	/**
	 * @generated from field: repeated bundles.v1.MappedValue column_mapping = 3;
	 */
	columnMapping?: MappedValueJson[];
};

/**
 * Describes the message bundles.v1.CsvLookup.
 * Use `create(CsvLookupSchema)` to create a new message.
 */
export const CsvLookupSchema: GenMessage<CsvLookup, { jsonType: CsvLookupJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 24);

/**
 * @generated from message bundles.v1.MappedValue
 */
export type MappedValue = Message<"bundles.v1.MappedValue"> & {
	/**
	 * @generated from field: string object_path = 1;
	 */
	objectPath: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: common.v1.DataType data_type = 3;
	 */
	dataType: DataType;

	/**
	 * @generated from field: google.protobuf.Value sample_value = 4;
	 */
	sampleValue?: Value | undefined;

	/**
	 * @generated from field: optional google.protobuf.Value default = 5;
	 */
	default?: Value | undefined;

	/**
	 * @generated from oneof bundles.v1.MappedValue.options
	 */
	options:
		| {
				/**
				 * @generated from field: bundles.v1.TimestampOptions timestamp = 6;
				 */
				value: TimestampOptions;
				case: "timestamp";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.MoneyOptions money = 7;
				 */
				value: MoneyOptions;
				case: "money";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PhoneOptions phone = 8;
				 */
				value: PhoneOptions;
				case: "phone";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.MappedValue
 */
export type MappedValueJson = {
	/**
	 * @generated from field: string object_path = 1;
	 */
	objectPath?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: common.v1.DataType data_type = 3;
	 */
	dataType?: DataTypeJson;

	/**
	 * @generated from field: google.protobuf.Value sample_value = 4;
	 */
	sampleValue?: ValueJson;

	/**
	 * @generated from field: optional google.protobuf.Value default = 5;
	 */
	default?: ValueJson;

	/**
	 * @generated from field: bundles.v1.TimestampOptions timestamp = 6;
	 */
	timestamp?: TimestampOptionsJson;

	/**
	 * @generated from field: bundles.v1.MoneyOptions money = 7;
	 */
	money?: MoneyOptionsJson;

	/**
	 * @generated from field: bundles.v1.PhoneOptions phone = 8;
	 */
	phone?: PhoneOptionsJson;
};

/**
 * Describes the message bundles.v1.MappedValue.
 * Use `create(MappedValueSchema)` to create a new message.
 */
export const MappedValueSchema: GenMessage<MappedValue, { jsonType: MappedValueJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 25);

/**
 * @generated from message bundles.v1.TimestampOptions
 */
export type TimestampOptions = Message<"bundles.v1.TimestampOptions"> & {
	/**
	 * @generated from field: string path = 1;
	 */
	path: string;

	/**
	 * @generated from field: string format = 2;
	 */
	format: string;
};

/**
 * @generated from message bundles.v1.TimestampOptions
 */
export type TimestampOptionsJson = {
	/**
	 * @generated from field: string path = 1;
	 */
	path?: string;

	/**
	 * @generated from field: string format = 2;
	 */
	format?: string;
};

/**
 * Describes the message bundles.v1.TimestampOptions.
 * Use `create(TimestampOptionsSchema)` to create a new message.
 */
export const TimestampOptionsSchema: GenMessage<TimestampOptions, { jsonType: TimestampOptionsJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 26);

/**
 * @generated from message bundles.v1.MoneyOptions
 */
export type MoneyOptions = Message<"bundles.v1.MoneyOptions"> & {
	/**
	 * @generated from field: string currency = 1;
	 */
	currency: string;
};

/**
 * @generated from message bundles.v1.MoneyOptions
 */
export type MoneyOptionsJson = {
	/**
	 * @generated from field: string currency = 1;
	 */
	currency?: string;
};

/**
 * Describes the message bundles.v1.MoneyOptions.
 * Use `create(MoneyOptionsSchema)` to create a new message.
 */
export const MoneyOptionsSchema: GenMessage<MoneyOptions, { jsonType: MoneyOptionsJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 27);

/**
 * @generated from message bundles.v1.PhoneOptions
 */
export type PhoneOptions = Message<"bundles.v1.PhoneOptions"> & {
	/**
	 * @generated from field: string country = 1;
	 */
	country: string;
};

/**
 * @generated from message bundles.v1.PhoneOptions
 */
export type PhoneOptionsJson = {
	/**
	 * @generated from field: string country = 1;
	 */
	country?: string;
};

/**
 * Describes the message bundles.v1.PhoneOptions.
 * Use `create(PhoneOptionsSchema)` to create a new message.
 */
export const PhoneOptionsSchema: GenMessage<PhoneOptions, { jsonType: PhoneOptionsJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 28);

/**
 * @generated from message bundles.v1.AdUnitConfig
 */
export type AdUnitConfig = Message<"bundles.v1.AdUnitConfig"> & {
	/**
	 * @generated from oneof bundles.v1.AdUnitConfig.config
	 */
	config:
		| {
				/**
				 * @generated from field: bundles.v1.TagConfig tag_config = 1;
				 */
				value: TagConfig;
				case: "tagConfig";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.AdUnitConfig
 */
export type AdUnitConfigJson = {
	/**
	 * @generated from field: bundles.v1.TagConfig tag_config = 1;
	 */
	tagConfig?: TagConfigJson;
};

/**
 * Describes the message bundles.v1.AdUnitConfig.
 * Use `create(AdUnitConfigSchema)` to create a new message.
 */
export const AdUnitConfigSchema: GenMessage<AdUnitConfig, { jsonType: AdUnitConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 29);

/**
 * @generated from message bundles.v1.TagConfig
 */
export type TagConfig = Message<"bundles.v1.TagConfig"> & {
	/**
	 * @generated from field: string tag = 1;
	 */
	tag: string;
};

/**
 * @generated from message bundles.v1.TagConfig
 */
export type TagConfigJson = {
	/**
	 * @generated from field: string tag = 1;
	 */
	tag?: string;
};

/**
 * Describes the message bundles.v1.TagConfig.
 * Use `create(TagConfigSchema)` to create a new message.
 */
export const TagConfigSchema: GenMessage<TagConfig, { jsonType: TagConfigJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 30);

/**
 * @generated from message bundles.v1.AdUnit
 */
export type AdUnit = Message<"bundles.v1.AdUnit"> & {
	/**
	 * @generated from oneof bundles.v1.AdUnit.content
	 */
	content:
		| {
				/**
				 * @generated from field: string html = 1;
				 */
				value: string;
				case: "html";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.AdUnit
 */
export type AdUnitJson = {
	/**
	 * @generated from field: string html = 1;
	 */
	html?: string;
};

/**
 * Describes the message bundles.v1.AdUnit.
 * Use `create(AdUnitSchema)` to create a new message.
 */
export const AdUnitSchema: GenMessage<AdUnit, { jsonType: AdUnitJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 31);

/**
 * @generated from message bundles.v1.Goto
 */
export type Goto = Message<"bundles.v1.Goto"> & {};

/**
 * @generated from message bundles.v1.Goto
 */
export type GotoJson = {};

/**
 * Describes the message bundles.v1.Goto.
 * Use `create(GotoSchema)` to create a new message.
 */
export const GotoSchema: GenMessage<Goto, { jsonType: GotoJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 32);

/**
 * @generated from message bundles.v1.Destination
 */
export type Destination = Message<"bundles.v1.Destination"> & {
	/**
	 * @generated from oneof bundles.v1.Destination.value
	 */
	value:
		| {
				/**
				 * @generated from field: bundles.v1.Asset asset = 1;
				 */
				value: Asset;
				case: "asset";
		  }
		| {
				/**
				 * @generated from field: string external_url = 2;
				 */
				value: string;
				case: "externalUrl";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: google.protobuf.Struct context = 3;
	 */
	context?: JsonObject | undefined;
};

/**
 * @generated from message bundles.v1.Destination
 */
export type DestinationJson = {
	/**
	 * @generated from field: bundles.v1.Asset asset = 1;
	 */
	asset?: AssetJson;

	/**
	 * @generated from field: string external_url = 2;
	 */
	externalUrl?: string;

	/**
	 * @generated from field: google.protobuf.Struct context = 3;
	 */
	context?: StructJson;
};

/**
 * Describes the message bundles.v1.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination, { jsonType: DestinationJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 33);

/**
 * @generated from message bundles.v1.Flow
 */
export type Flow = Message<"bundles.v1.Flow"> & {
	/**
	 * @generated from field: string rules = 1;
	 */
	rules: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 2;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: string conversion_component = 4;
	 */
	conversionComponent: string;

	/**
	 * @generated from field: bool disabled = 3;
	 */
	disabled: boolean;
};

/**
 * @generated from message bundles.v1.Flow
 */
export type FlowJson = {
	/**
	 * @generated from field: string rules = 1;
	 */
	rules?: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 2;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: string conversion_component = 4;
	 */
	conversionComponent?: string;

	/**
	 * @generated from field: bool disabled = 3;
	 */
	disabled?: boolean;
};

/**
 * Describes the message bundles.v1.Flow.
 * Use `create(FlowSchema)` to create a new message.
 */
export const FlowSchema: GenMessage<Flow, { jsonType: FlowJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 34);

/**
 * Entrypoint is an asset a user has interacted with to initially enter a suite (BATCH or CODE_V3)
 *
 * @generated from message bundles.v1.EntryPoint
 */
export type EntryPoint = Message<"bundles.v1.EntryPoint"> & {
	/**
	 * The key within suite.assets that points to this asset (BATCH or CODE_V3), set even on scan events
	 *
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * The id of the underlying asset, this will always be an instance of a CODE_V3 (ie. the code inside the batch referenced by key)
	 *
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * Entrypoint is an asset a user has interacted with to initially enter a suite (BATCH or CODE_V3)
 *
 * @generated from message bundles.v1.EntryPoint
 */
export type EntryPointJson = {
	/**
	 * The key within suite.assets that points to this asset (BATCH or CODE_V3), set even on scan events
	 *
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * The id of the underlying asset, this will always be an instance of a CODE_V3 (ie. the code inside the batch referenced by key)
	 *
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.EntryPoint.
 * Use `create(EntryPointSchema)` to create a new message.
 */
export const EntryPointSchema: GenMessage<EntryPoint, { jsonType: EntryPointJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 35);

/**
 * Data is a message that represents the data that is associated with a suite.
 *
 * @generated from message bundles.v1.Data
 */
export type Data = Message<"bundles.v1.Data"> & {
	/**
	 * @generated from oneof bundles.v1.Data.type
	 */
	type:
		| {
				/**
				 * @generated from field: bundles.v1.RealEstateData real_estate = 1;
				 */
				value: RealEstateData;
				case: "realEstate";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.CommerceData commerce = 2;
				 */
				value: CommerceData;
				case: "commerce";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.FormData form = 3;
				 */
				value: FormData;
				case: "form";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.ContactData contact = 4;
				 */
				value: ContactData;
				case: "contact";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: map<string, bundles.v1.DataSet> additional_datasets = 5;
	 */
	additionalDatasets: { [key: string]: DataSet };
};

/**
 * Data is a message that represents the data that is associated with a suite.
 *
 * @generated from message bundles.v1.Data
 */
export type DataJson = {
	/**
	 * @generated from field: bundles.v1.RealEstateData real_estate = 1;
	 */
	realEstate?: RealEstateDataJson;

	/**
	 * @generated from field: bundles.v1.CommerceData commerce = 2;
	 */
	commerce?: CommerceDataJson;

	/**
	 * @generated from field: bundles.v1.FormData form = 3;
	 */
	form?: FormDataJson;

	/**
	 * @generated from field: bundles.v1.ContactData contact = 4;
	 */
	contact?: ContactDataJson;

	/**
	 * @generated from field: map<string, bundles.v1.DataSet> additional_datasets = 5;
	 */
	additionalDatasets?: { [key: string]: DataSetJson };
};

/**
 * Describes the message bundles.v1.Data.
 * Use `create(DataSchema)` to create a new message.
 */
export const DataSchema: GenMessage<Data, { jsonType: DataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 36);

/**
 * Dataset is a dynamic collection of data that can be referenced within a suite.
 *
 * @generated from message bundles.v1.DataSet
 */
export type DataSet = Message<"bundles.v1.DataSet"> & {
	/**
	 * Name is the unique identifier for the dataset within the suite.
	 *
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * Description provides a human-readable explanation of the dataset.
	 *
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * Lookup the actual lookup to perform to populate this dataset.
	 *
	 * @generated from field: bundles.v1.Lookup lookup = 3;
	 */
	lookup?: Lookup | undefined;

	/**
	 * Is Deferred indicates whether the dataset is deferred, meaning it may not be immediately available and could be populated at a later time.
	 *
	 * @generated from field: bool is_deferred = 4;
	 */
	isDeferred: boolean;
};

/**
 * Dataset is a dynamic collection of data that can be referenced within a suite.
 *
 * @generated from message bundles.v1.DataSet
 */
export type DataSetJson = {
	/**
	 * Name is the unique identifier for the dataset within the suite.
	 *
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * Description provides a human-readable explanation of the dataset.
	 *
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * Lookup the actual lookup to perform to populate this dataset.
	 *
	 * @generated from field: bundles.v1.Lookup lookup = 3;
	 */
	lookup?: LookupJson;

	/**
	 * Is Deferred indicates whether the dataset is deferred, meaning it may not be immediately available and could be populated at a later time.
	 *
	 * @generated from field: bool is_deferred = 4;
	 */
	isDeferred?: boolean;
};

/**
 * Describes the message bundles.v1.DataSet.
 * Use `create(DataSetSchema)` to create a new message.
 */
export const DataSetSchema: GenMessage<DataSet, { jsonType: DataSetJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 37);

/**
 * Bundle is a structure to represent a set of asset templates and links between those templates. Bundles are instantiated as a suite during the creation process.
 *
 * @generated from message bundles.v1.Bundle
 */
export type Bundle = Message<"bundles.v1.Bundle"> & {
	/**
	 * ID is the UUID of the Bundle
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string dag_version = 21;
	 */
	dagVersion: string;

	/**
	 * @generated from field: string version = 19;
	 */
	version: string;

	/**
	 * Bundle Type is the type of bundle that is being created.
	 *
	 * @generated from field: bundles.v1.BundleType bundle_type = 15;
	 */
	bundleType: BundleType;

	/**
	 * Category is an arbitrary string that can be used to categorize the bundle for template listings.
	 *
	 * @generated from field: string category = 20;
	 */
	category: string;

	/**
	 * Verticals are the industries this bundle template applies to.
	 *
	 * @generated from field: repeated string verticals = 23;
	 */
	verticals: string[];

	/**
	 * Features are the capabilities this bundle template advertises.
	 *
	 * @generated from field: repeated string features = 24;
	 */
	features: string[];

	/**
	 * @generated from field: optional string group_id = 2;
	 */
	groupId?: string | undefined;

	/**
	 * Org ID is the organization that the bundle belongs to.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the bundle belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string state = 5;
	 */
	state: string;

	/**
	 * @generated from field: string archive_reason = 16;
	 */
	archiveReason: string;

	/**
	 * Creator is the person who created the bundle.
	 *
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * Name is the name of the bundle.
	 *
	 * @generated from field: string name = 7;
	 */
	name: string;

	/**
	 * Description is an optional description of the bundle.
	 *
	 * @generated from field: optional string description = 8;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath: string;

	/**
	 * Tags are a set of strings that can be used to categorize the bundle in various ways.
	 *
	 * @generated from field: repeated string tags = 10;
	 */
	tags: string[];

	/**
	 * @generated from field: string visibility = 17;
	 */
	visibility: string;

	/**
	 * Default Presentation Mode is the template-authored default that seeds Suite.default_presentation_mode for suites created from this bundle.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 22;
	 */
	defaultPresentationMode: PresentationMode;

	/**
	 * Templates is a map of template references that are used to create assets in a suite.
	 *
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 11;
	 */
	templates: { [key: string]: TemplateRef };

	/**
	 * Links represent how templates are connected in the bundle.
	 *
	 * @generated from field: repeated bundles.v1.Link links = 12;
	 */
	links: Link[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 18;
	 */
	archivedAt?: Timestamp | undefined;
};

/**
 * Bundle is a structure to represent a set of asset templates and links between those templates. Bundles are instantiated as a suite during the creation process.
 *
 * @generated from message bundles.v1.Bundle
 */
export type BundleJson = {
	/**
	 * ID is the UUID of the Bundle
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string dag_version = 21;
	 */
	dagVersion?: string;

	/**
	 * @generated from field: string version = 19;
	 */
	version?: string;

	/**
	 * Bundle Type is the type of bundle that is being created.
	 *
	 * @generated from field: bundles.v1.BundleType bundle_type = 15;
	 */
	bundleType?: BundleTypeJson;

	/**
	 * Category is an arbitrary string that can be used to categorize the bundle for template listings.
	 *
	 * @generated from field: string category = 20;
	 */
	category?: string;

	/**
	 * Verticals are the industries this bundle template applies to.
	 *
	 * @generated from field: repeated string verticals = 23;
	 */
	verticals?: string[];

	/**
	 * Features are the capabilities this bundle template advertises.
	 *
	 * @generated from field: repeated string features = 24;
	 */
	features?: string[];

	/**
	 * @generated from field: optional string group_id = 2;
	 */
	groupId?: string;

	/**
	 * Org ID is the organization that the bundle belongs to.
	 *
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the bundle belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string state = 5;
	 */
	state?: string;

	/**
	 * @generated from field: string archive_reason = 16;
	 */
	archiveReason?: string;

	/**
	 * Creator is the person who created the bundle.
	 *
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * Name is the name of the bundle.
	 *
	 * @generated from field: string name = 7;
	 */
	name?: string;

	/**
	 * Description is an optional description of the bundle.
	 *
	 * @generated from field: optional string description = 8;
	 */
	description?: string;

	/**
	 * @generated from field: string folder_path = 9;
	 */
	folderPath?: string;

	/**
	 * Tags are a set of strings that can be used to categorize the bundle in various ways.
	 *
	 * @generated from field: repeated string tags = 10;
	 */
	tags?: string[];

	/**
	 * @generated from field: string visibility = 17;
	 */
	visibility?: string;

	/**
	 * Default Presentation Mode is the template-authored default that seeds Suite.default_presentation_mode for suites created from this bundle.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 22;
	 */
	defaultPresentationMode?: PresentationModeJson;

	/**
	 * Templates is a map of template references that are used to create assets in a suite.
	 *
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 11;
	 */
	templates?: { [key: string]: TemplateRefJson };

	/**
	 * Links represent how templates are connected in the bundle.
	 *
	 * @generated from field: repeated bundles.v1.Link links = 12;
	 */
	links?: LinkJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp archived_at = 18;
	 */
	archivedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Bundle.
 * Use `create(BundleSchema)` to create a new message.
 */
export const BundleSchema: GenMessage<Bundle, { jsonType: BundleJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 38);

/**
 * @generated from message bundles.v1.ModuleTemplate
 */
export type ModuleTemplate = Message<"bundles.v1.ModuleTemplate"> & {
	/**
	 * The id of this module template
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * The specific version of the module template
	 *
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 3;
	 */
	dagVersion: string;

	/**
	 * The list of bundle types that this module template supports
	 *
	 * @generated from field: repeated bundles.v1.BundleType supported_bundle_types = 4;
	 */
	supportedBundleTypes: BundleType[];

	/**
	 * The category of the module template
	 *
	 * @generated from field: string category = 5;
	 */
	category: string;

	/**
	 * The organization this module template is associated with
	 *
	 * @generated from field: string org_id = 6;
	 */
	orgId: string;

	/**
	 * The workspace this module template is associated with
	 *
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId: string;

	/**
	 * The state of the module template
	 *
	 * @generated from field: string state = 8;
	 */
	state: string;

	/**
	 * The reason the module template was archived
	 *
	 * @generated from field: string archive_reason = 9;
	 */
	archiveReason: string;

	/**
	 * The creator of the module template
	 *
	 * @generated from field: common.v1.Creator creator = 10;
	 */
	creator?: Creator | undefined;

	/**
	 * The name of the module template
	 *
	 * @generated from field: string name = 11;
	 */
	name: string;

	/**
	 * The description of the module template
	 *
	 * @generated from field: optional string description = 12;
	 */
	description?: string | undefined;

	/**
	 * The folder path of the module template
	 *
	 * @generated from field: string folder_path = 13;
	 */
	folderPath: string;

	/**
	 * Tags associated with the module template
	 *
	 * @generated from field: repeated string tags = 14;
	 */
	tags: string[];

	/**
	 * The visibility of this module template
	 *
	 * @generated from field: string visibility = 15;
	 */
	visibility: string;

	/**
	 * The templates associated with this module template
	 *
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 16;
	 */
	templates: { [key: string]: TemplateRef };

	/**
	 * The links between templates in this module template
	 *
	 * @generated from field: repeated bundles.v1.Link links = 17;
	 */
	links: Link[];

	/**
	 * The entry point for this module template
	 *
	 * @generated from field: string entry_point = 18;
	 */
	entryPoint: string;

	/**
	 * The schema for the config of this module template
	 *
	 * @generated from field: string config_schema = 19;
	 */
	configSchema: string;

	/**
	 * icon url
	 *
	 * @generated from field: string icon_url = 25;
	 */
	iconUrl: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 24;
	 */
	supportedRenderModes: RenderMode[];

	/**
	 * The timestamp at which this module template was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * The timestamp at which this module template was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 22;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * The timestamp at which this module template was archived
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 23;
	 */
	archivedAt?: Timestamp | undefined;
};

/**
 * @generated from message bundles.v1.ModuleTemplate
 */
export type ModuleTemplateJson = {
	/**
	 * The id of this module template
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * The specific version of the module template
	 *
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 3;
	 */
	dagVersion?: string;

	/**
	 * The list of bundle types that this module template supports
	 *
	 * @generated from field: repeated bundles.v1.BundleType supported_bundle_types = 4;
	 */
	supportedBundleTypes?: BundleTypeJson[];

	/**
	 * The category of the module template
	 *
	 * @generated from field: string category = 5;
	 */
	category?: string;

	/**
	 * The organization this module template is associated with
	 *
	 * @generated from field: string org_id = 6;
	 */
	orgId?: string;

	/**
	 * The workspace this module template is associated with
	 *
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId?: string;

	/**
	 * The state of the module template
	 *
	 * @generated from field: string state = 8;
	 */
	state?: string;

	/**
	 * The reason the module template was archived
	 *
	 * @generated from field: string archive_reason = 9;
	 */
	archiveReason?: string;

	/**
	 * The creator of the module template
	 *
	 * @generated from field: common.v1.Creator creator = 10;
	 */
	creator?: CreatorJson;

	/**
	 * The name of the module template
	 *
	 * @generated from field: string name = 11;
	 */
	name?: string;

	/**
	 * The description of the module template
	 *
	 * @generated from field: optional string description = 12;
	 */
	description?: string;

	/**
	 * The folder path of the module template
	 *
	 * @generated from field: string folder_path = 13;
	 */
	folderPath?: string;

	/**
	 * Tags associated with the module template
	 *
	 * @generated from field: repeated string tags = 14;
	 */
	tags?: string[];

	/**
	 * The visibility of this module template
	 *
	 * @generated from field: string visibility = 15;
	 */
	visibility?: string;

	/**
	 * The templates associated with this module template
	 *
	 * @generated from field: map<string, bundles.v1.TemplateRef> templates = 16;
	 */
	templates?: { [key: string]: TemplateRefJson };

	/**
	 * The links between templates in this module template
	 *
	 * @generated from field: repeated bundles.v1.Link links = 17;
	 */
	links?: LinkJson[];

	/**
	 * The entry point for this module template
	 *
	 * @generated from field: string entry_point = 18;
	 */
	entryPoint?: string;

	/**
	 * The schema for the config of this module template
	 *
	 * @generated from field: string config_schema = 19;
	 */
	configSchema?: string;

	/**
	 * icon url
	 *
	 * @generated from field: string icon_url = 25;
	 */
	iconUrl?: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 24;
	 */
	supportedRenderModes?: RenderModeJson[];

	/**
	 * The timestamp at which this module template was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: TimestampJson;

	/**
	 * The timestamp at which this module template was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 22;
	 */
	updatedAt?: TimestampJson;

	/**
	 * The timestamp at which this module template was archived
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 23;
	 */
	archivedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.ModuleTemplate.
 * Use `create(ModuleTemplateSchema)` to create a new message.
 */
export const ModuleTemplateSchema: GenMessage<ModuleTemplate, { jsonType: ModuleTemplateJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 39);

/**
 * @generated from message bundles.v1.Module
 */
export type Module = Message<"bundles.v1.Module"> & {
	/**
	 * The id of this module instance
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * The specific version of the module
	 *
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 3;
	 */
	dagVersion: string;

	/**
	 * The id of the module template this module was created from
	 *
	 * @generated from field: string template_id = 4;
	 */
	templateId: string;

	/**
	 * The version of the module template this module was created from
	 *
	 * @generated from field: string template_version = 5;
	 */
	templateVersion: string;

	/**
	 * The id of the brand kit this module is associated with
	 *
	 * @generated from field: optional string brand_kit_id = 6;
	 */
	brandKitId?: string | undefined;

	/**
	 * The organization this module is associated with
	 *
	 * @generated from field: string org_id = 7;
	 */
	orgId: string;

	/**
	 * The workspace this module is associated with
	 *
	 * @generated from field: string workspace_id = 8;
	 */
	workspaceId: string;

	/**
	 * The state of the module
	 *
	 * @generated from field: string state = 9;
	 */
	state: string;

	/**
	 * The reason the module was archived
	 *
	 * @generated from field: string archive_reason = 10;
	 */
	archiveReason: string;

	/**
	 * The creator of the module
	 *
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: Creator | undefined;

	/**
	 * The name of the module
	 *
	 * @generated from field: string name = 12;
	 */
	name: string;

	/**
	 * An optional description of the module
	 *
	 * @generated from field: optional string description = 13;
	 */
	description?: string | undefined;

	/**
	 * The folder path of the module
	 *
	 * @generated from field: string folder_path = 14;
	 */
	folderPath: string;

	/**
	 * Tags associated with the module
	 *
	 * @generated from field: repeated string tags = 15;
	 */
	tags: string[];

	/**
	 * The domain to use with this module
	 *
	 * @generated from field: string domain = 16;
	 */
	domain: string;

	/**
	 * The assets associated with this module
	 *
	 * @generated from field: map<string, bundles.v1.AssetRef> assets = 17;
	 */
	assets: { [key: string]: AssetRef };

	/**
	 * The set of links between assets in this module
	 *
	 * @generated from field: repeated bundles.v1.Link links = 18;
	 */
	links: Link[];

	/**
	 * The entry point for this module
	 *
	 * @generated from field: string entry_point = 19;
	 */
	entryPoint: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 24;
	 */
	supportedRenderModes: RenderMode[];

	/**
	 * The timestamp at which this mocdule was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * The timestamp at which this module was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 21;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * The timestamp at which this module was archived
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 22;
	 */
	archivedAt?: Timestamp | undefined;
};

/**
 * @generated from message bundles.v1.Module
 */
export type ModuleJson = {
	/**
	 * The id of this module instance
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * The specific version of the module
	 *
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 3;
	 */
	dagVersion?: string;

	/**
	 * The id of the module template this module was created from
	 *
	 * @generated from field: string template_id = 4;
	 */
	templateId?: string;

	/**
	 * The version of the module template this module was created from
	 *
	 * @generated from field: string template_version = 5;
	 */
	templateVersion?: string;

	/**
	 * The id of the brand kit this module is associated with
	 *
	 * @generated from field: optional string brand_kit_id = 6;
	 */
	brandKitId?: string;

	/**
	 * The organization this module is associated with
	 *
	 * @generated from field: string org_id = 7;
	 */
	orgId?: string;

	/**
	 * The workspace this module is associated with
	 *
	 * @generated from field: string workspace_id = 8;
	 */
	workspaceId?: string;

	/**
	 * The state of the module
	 *
	 * @generated from field: string state = 9;
	 */
	state?: string;

	/**
	 * The reason the module was archived
	 *
	 * @generated from field: string archive_reason = 10;
	 */
	archiveReason?: string;

	/**
	 * The creator of the module
	 *
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: CreatorJson;

	/**
	 * The name of the module
	 *
	 * @generated from field: string name = 12;
	 */
	name?: string;

	/**
	 * An optional description of the module
	 *
	 * @generated from field: optional string description = 13;
	 */
	description?: string;

	/**
	 * The folder path of the module
	 *
	 * @generated from field: string folder_path = 14;
	 */
	folderPath?: string;

	/**
	 * Tags associated with the module
	 *
	 * @generated from field: repeated string tags = 15;
	 */
	tags?: string[];

	/**
	 * The domain to use with this module
	 *
	 * @generated from field: string domain = 16;
	 */
	domain?: string;

	/**
	 * The assets associated with this module
	 *
	 * @generated from field: map<string, bundles.v1.AssetRef> assets = 17;
	 */
	assets?: { [key: string]: AssetRefJson };

	/**
	 * The set of links between assets in this module
	 *
	 * @generated from field: repeated bundles.v1.Link links = 18;
	 */
	links?: LinkJson[];

	/**
	 * The entry point for this module
	 *
	 * @generated from field: string entry_point = 19;
	 */
	entryPoint?: string;

	/**
	 * @generated from field: repeated bundles.v1.RenderMode supported_render_modes = 24;
	 */
	supportedRenderModes?: RenderModeJson[];

	/**
	 * The timestamp at which this mocdule was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 20;
	 */
	createdAt?: TimestampJson;

	/**
	 * The timestamp at which this module was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 21;
	 */
	updatedAt?: TimestampJson;

	/**
	 * The timestamp at which this module was archived
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 22;
	 */
	archivedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Module.
 * Use `create(ModuleSchema)` to create a new message.
 */
export const ModuleSchema: GenMessage<Module, { jsonType: ModuleJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 40);

/**
 * A SuiteRef is a reference to a suite that can be used in a bundle or module. It allows for linking to an existing suite without duplicating its data.
 *
 * @generated from message bundles.v1.SuiteRef
 */
export type SuiteRef = Message<"bundles.v1.SuiteRef"> & {
	/**
	 * The ID of the suite that this reference points to
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * The entry point id to forard to
	 *
	 * @generated from field: string entry_point = 2;
	 */
	entryPoint: string;
};

/**
 * A SuiteRef is a reference to a suite that can be used in a bundle or module. It allows for linking to an existing suite without duplicating its data.
 *
 * @generated from message bundles.v1.SuiteRef
 */
export type SuiteRefJson = {
	/**
	 * The ID of the suite that this reference points to
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * The entry point id to forard to
	 *
	 * @generated from field: string entry_point = 2;
	 */
	entryPoint?: string;
};

/**
 * Describes the message bundles.v1.SuiteRef.
 * Use `create(SuiteRefSchema)` to create a new message.
 */
export const SuiteRefSchema: GenMessage<SuiteRef, { jsonType: SuiteRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 41);

/**
 * A EntryPointBatchRef is a reference to an entry point batch from a separate suite. It allows for linking to an existing entry point batch without duplicating its data.
 *
 * @generated from message bundles.v1.EntryPointBatchRef
 */
export type EntryPointBatchRef = Message<"bundles.v1.EntryPointBatchRef"> & {
	/**
	 * The ID of the source suite that this reference points to
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId: string;

	/**
	 * The ID of the source entry point batch this reference points to
	 *
	 * @generated from field: string entry_point_batch_id = 2;
	 */
	entryPointBatchId: string;
};

/**
 * A EntryPointBatchRef is a reference to an entry point batch from a separate suite. It allows for linking to an existing entry point batch without duplicating its data.
 *
 * @generated from message bundles.v1.EntryPointBatchRef
 */
export type EntryPointBatchRefJson = {
	/**
	 * The ID of the source suite that this reference points to
	 *
	 * @generated from field: string suite_id = 1;
	 */
	suiteId?: string;

	/**
	 * The ID of the source entry point batch this reference points to
	 *
	 * @generated from field: string entry_point_batch_id = 2;
	 */
	entryPointBatchId?: string;
};

/**
 * Describes the message bundles.v1.EntryPointBatchRef.
 * Use `create(EntryPointBatchRefSchema)` to create a new message.
 */
export const EntryPointBatchRefSchema: GenMessage<EntryPointBatchRef, { jsonType: EntryPointBatchRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 42);

/**
 * StaticAssetRef is a reference to a static asset
 *
 * @generated from message bundles.v1.StaticAssetRef
 */
export type StaticAssetRef = Message<"bundles.v1.StaticAssetRef"> & {
	/**
	 * The ID of the static asset
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * StaticAssetRef is a reference to a static asset
 *
 * @generated from message bundles.v1.StaticAssetRef
 */
export type StaticAssetRefJson = {
	/**
	 * The ID of the static asset
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.StaticAssetRef.
 * Use `create(StaticAssetRefSchema)` to create a new message.
 */
export const StaticAssetRefSchema: GenMessage<StaticAssetRef, { jsonType: StaticAssetRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 43);

/**
 * PolicyRef is a reference to a terms and conditions policy asset
 *
 * @generated from message bundles.v1.PolicyRef
 */
export type PolicyRef = Message<"bundles.v1.PolicyRef"> & {
	/**
	 * The ID of the terms and conditions policy asset
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * The version of the terms and conditions policy asset
	 *
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * PolicyRef is a reference to a terms and conditions policy asset
 *
 * @generated from message bundles.v1.PolicyRef
 */
export type PolicyRefJson = {
	/**
	 * The ID of the terms and conditions policy asset
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * The version of the terms and conditions policy asset
	 *
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message bundles.v1.PolicyRef.
 * Use `create(PolicyRefSchema)` to create a new message.
 */
export const PolicyRefSchema: GenMessage<PolicyRef, { jsonType: PolicyRefJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 44);

/**
 * Agent is a connection to an AI integration that can be used to enhance the capabilities of a suite.
 *
 * @generated from message bundles.v1.Agent
 */
export type Agent = Message<"bundles.v1.Agent"> & {
	/**
	 * The unique identifier for the integration.
	 *
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * The model of the AI integration.
	 *
	 * @generated from field: string model = 2;
	 */
	model: string;

	/**
	 * The prompt template to use with the AI integration.
	 *
	 * @generated from field: string prompt_template = 3;
	 */
	promptTemplate: string;

	/**
	 * The response type to expect from the AI integration.
	 *
	 * @generated from field: bundles.v1.ResponseType response_type = 4;
	 */
	responseType: ResponseType;
};

/**
 * Agent is a connection to an AI integration that can be used to enhance the capabilities of a suite.
 *
 * @generated from message bundles.v1.Agent
 */
export type AgentJson = {
	/**
	 * The unique identifier for the integration.
	 *
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * The model of the AI integration.
	 *
	 * @generated from field: string model = 2;
	 */
	model?: string;

	/**
	 * The prompt template to use with the AI integration.
	 *
	 * @generated from field: string prompt_template = 3;
	 */
	promptTemplate?: string;

	/**
	 * The response type to expect from the AI integration.
	 *
	 * @generated from field: bundles.v1.ResponseType response_type = 4;
	 */
	responseType?: ResponseTypeJson;
};

/**
 * Describes the message bundles.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent, { jsonType: AgentJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 45);

/**
 * CustomCode holds raw markup injected verbatim into every page of the suite.
 * Content is inserted as-is (may contain <script>, <meta>, <link>, <style>), so the
 * author is responsible for well-formed, correctly ordered tags. Applies flow-wide.
 *
 * @generated from message bundles.v1.CustomCode
 */
export type CustomCode = Message<"bundles.v1.CustomCode"> & {
	/**
	 * Injected at the end of <head> on every page in the suite.
	 *
	 * @generated from field: string head = 1;
	 */
	head: string;

	/**
	 * Injected immediately after the opening <body> on every page in the suite.
	 *
	 * @generated from field: string body_start = 2;
	 */
	bodyStart: string;

	/**
	 * Injected immediately before the closing </body> on every page in the suite.
	 *
	 * @generated from field: string body_end = 3;
	 */
	bodyEnd: string;
};

/**
 * CustomCode holds raw markup injected verbatim into every page of the suite.
 * Content is inserted as-is (may contain <script>, <meta>, <link>, <style>), so the
 * author is responsible for well-formed, correctly ordered tags. Applies flow-wide.
 *
 * @generated from message bundles.v1.CustomCode
 */
export type CustomCodeJson = {
	/**
	 * Injected at the end of <head> on every page in the suite.
	 *
	 * @generated from field: string head = 1;
	 */
	head?: string;

	/**
	 * Injected immediately after the opening <body> on every page in the suite.
	 *
	 * @generated from field: string body_start = 2;
	 */
	bodyStart?: string;

	/**
	 * Injected immediately before the closing </body> on every page in the suite.
	 *
	 * @generated from field: string body_end = 3;
	 */
	bodyEnd?: string;
};

/**
 * Describes the message bundles.v1.CustomCode.
 * Use `create(CustomCodeSchema)` to create a new message.
 */
export const CustomCodeSchema: GenMessage<CustomCode, { jsonType: CustomCodeJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 46);

/**
 * Suite is an instantiation of a Bundle. It is the primary object that is created and managed by the user to create a conversion flow.
 *
 * @generated from message bundles.v1.Suite
 */
export type Suite = Message<"bundles.v1.Suite"> & {
	/**
	 * ID is the unique identifier for the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * Version is the version of the suite.
	 *
	 * @generated from field: string version = 27;
	 */
	version: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 28;
	 */
	dagVersion: string;

	/**
	 * Bundle Type is the type of bundle that the suite is based on.
	 *
	 * @generated from field: bundles.v1.BundleType bundle_type = 17;
	 */
	bundleType: BundleType;

	/**
	 * Category is an arbitrary string that can be used to categorize the suite for template listings.
	 *
	 * @generated from field: string category = 21;
	 */
	category: string;

	/**
	 * Bundle ID is the unique identifier for the bundle that the suite is based on.
	 *
	 * @generated from field: string bundle_id = 2;
	 */
	bundleId: string;

	/**
	 * Bundle Version is the version of the bundle that the suite was originally created from, as the bundle may have multiple versions.
	 *
	 * @generated from field: string bundle_version = 23;
	 */
	bundleVersion: string;

	/**
	 * Brand Kit ID is the unique identifier for the brand kit that the suite is associated with.
	 *
	 * @generated from field: optional string brand_kit_id = 3;
	 */
	brandKitId?: string | undefined;

	/**
	 * Org ID is the organization that the suite belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the suite belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * State respresents the current state of the suite. Valid values are active, archived or draft.
	 *
	 * @generated from field: string state = 6;
	 */
	state: string;

	/**
	 * Archive Reason is optional informational text as to why the suite was archived.
	 *
	 * @generated from field: string archive_reason = 19;
	 */
	archiveReason: string;

	/**
	 * Creator is the person who created the suite.
	 *
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: Creator | undefined;

	/**
	 * Name is the name of the suite.
	 *
	 * @generated from field: string name = 8;
	 */
	name: string;

	/**
	 * Description is an optional description of the suite.
	 *
	 * @generated from field: optional string description = 9;
	 */
	description?: string | undefined;

	/**
	 * The path to the folder where the suite is located.
	 *
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * The ID of the folder where the suite is located.
	 *
	 * @generated from field: string folder_id = 26;
	 */
	folderId: string;

	/**
	 * Tags are a set of strings that can be used to categorize the suite in various ways.
	 *
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * The custom domain used with this suite.
	 *
	 * @generated from field: string domain = 12;
	 */
	domain: string;

	/**
	 * Assets is the set of key/value pairs of instantiated assets in the suite, created from the Bundle's TemplateRefs.
	 *
	 * @generated from field: map<string, bundles.v1.AssetRef> assets = 13;
	 */
	assets: { [key: string]: AssetRef };

	/**
	 * Flows are how Assets in the Suite are connected to each other.
	 *
	 * @generated from field: map<string, bundles.v1.Flow> flows = 14;
	 */
	flows: { [key: string]: Flow };

	/**
	 * Links represent how templates are connected in the bundle.
	 *
	 * @generated from field: repeated bundles.v1.Link links = 24;
	 */
	links: Link[];

	/**
	 * The set of data that is associated with the suite. This is dependent on the bundle type.
	 *
	 * @generated from field: bundles.v1.Data data = 18;
	 */
	data?: Data | undefined;

	/**
	 * Advanced Geo Enabled is a boolean to determine if the suite will have advanced geo capabilities on by default.
	 *
	 * @generated from field: bool advanced_geo_enabled = 22;
	 */
	advancedGeoEnabled: boolean;

	/**
	 * The specific timeezone to use when resolving time-based rules. If not set,
	 * the timezone of the scanner will be used.
	 *
	 * @generated from field: optional string timezone = 25;
	 */
	timezone?: string | undefined;

	/**
	 * The ids of the calendar instances to use for scheduling rules
	 *
	 * @generated from field: repeated string calendar_ids = 30;
	 */
	calendarIds: string[];

	/**
	 * Allows Page type assets to be viewed in Desktop Mode
	 *
	 * @generated from field: bool desktop_view_enabled = 29;
	 */
	desktopViewEnabled: boolean;

	/**
	 * Custom Code is raw markup injected into every page of the suite (head/body). Applies flow-wide.
	 *
	 * @generated from field: optional bundles.v1.CustomCode custom_code = 31;
	 */
	customCode?: CustomCode | undefined;

	/**
	 * Default Presentation Mode is the flow-level default applied to newly created pages in the flow.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 32;
	 */
	defaultPresentationMode: PresentationMode;

	/**
	 * Created At is the timestamp when the suite was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * Updated At is the timestamp when the suite was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * Archived At is the timestamp when the suite was archived. This is only relevant if the state field is set to archived.
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: Timestamp | undefined;
};

/**
 * Suite is an instantiation of a Bundle. It is the primary object that is created and managed by the user to create a conversion flow.
 *
 * @generated from message bundles.v1.Suite
 */
export type SuiteJson = {
	/**
	 * ID is the unique identifier for the suite.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * Version is the version of the suite.
	 *
	 * @generated from field: string version = 27;
	 */
	version?: string;

	/**
	 * The version of the underlying DAG
	 *
	 * @generated from field: string dag_version = 28;
	 */
	dagVersion?: string;

	/**
	 * Bundle Type is the type of bundle that the suite is based on.
	 *
	 * @generated from field: bundles.v1.BundleType bundle_type = 17;
	 */
	bundleType?: BundleTypeJson;

	/**
	 * Category is an arbitrary string that can be used to categorize the suite for template listings.
	 *
	 * @generated from field: string category = 21;
	 */
	category?: string;

	/**
	 * Bundle ID is the unique identifier for the bundle that the suite is based on.
	 *
	 * @generated from field: string bundle_id = 2;
	 */
	bundleId?: string;

	/**
	 * Bundle Version is the version of the bundle that the suite was originally created from, as the bundle may have multiple versions.
	 *
	 * @generated from field: string bundle_version = 23;
	 */
	bundleVersion?: string;

	/**
	 * Brand Kit ID is the unique identifier for the brand kit that the suite is associated with.
	 *
	 * @generated from field: optional string brand_kit_id = 3;
	 */
	brandKitId?: string;

	/**
	 * Org ID is the organization that the suite belongs to.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the suite belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * State respresents the current state of the suite. Valid values are active, archived or draft.
	 *
	 * @generated from field: string state = 6;
	 */
	state?: string;

	/**
	 * Archive Reason is optional informational text as to why the suite was archived.
	 *
	 * @generated from field: string archive_reason = 19;
	 */
	archiveReason?: string;

	/**
	 * Creator is the person who created the suite.
	 *
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: CreatorJson;

	/**
	 * Name is the name of the suite.
	 *
	 * @generated from field: string name = 8;
	 */
	name?: string;

	/**
	 * Description is an optional description of the suite.
	 *
	 * @generated from field: optional string description = 9;
	 */
	description?: string;

	/**
	 * The path to the folder where the suite is located.
	 *
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * The ID of the folder where the suite is located.
	 *
	 * @generated from field: string folder_id = 26;
	 */
	folderId?: string;

	/**
	 * Tags are a set of strings that can be used to categorize the suite in various ways.
	 *
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * The custom domain used with this suite.
	 *
	 * @generated from field: string domain = 12;
	 */
	domain?: string;

	/**
	 * Assets is the set of key/value pairs of instantiated assets in the suite, created from the Bundle's TemplateRefs.
	 *
	 * @generated from field: map<string, bundles.v1.AssetRef> assets = 13;
	 */
	assets?: { [key: string]: AssetRefJson };

	/**
	 * Flows are how Assets in the Suite are connected to each other.
	 *
	 * @generated from field: map<string, bundles.v1.Flow> flows = 14;
	 */
	flows?: { [key: string]: FlowJson };

	/**
	 * Links represent how templates are connected in the bundle.
	 *
	 * @generated from field: repeated bundles.v1.Link links = 24;
	 */
	links?: LinkJson[];

	/**
	 * The set of data that is associated with the suite. This is dependent on the bundle type.
	 *
	 * @generated from field: bundles.v1.Data data = 18;
	 */
	data?: DataJson;

	/**
	 * Advanced Geo Enabled is a boolean to determine if the suite will have advanced geo capabilities on by default.
	 *
	 * @generated from field: bool advanced_geo_enabled = 22;
	 */
	advancedGeoEnabled?: boolean;

	/**
	 * The specific timeezone to use when resolving time-based rules. If not set,
	 * the timezone of the scanner will be used.
	 *
	 * @generated from field: optional string timezone = 25;
	 */
	timezone?: string;

	/**
	 * The ids of the calendar instances to use for scheduling rules
	 *
	 * @generated from field: repeated string calendar_ids = 30;
	 */
	calendarIds?: string[];

	/**
	 * Allows Page type assets to be viewed in Desktop Mode
	 *
	 * @generated from field: bool desktop_view_enabled = 29;
	 */
	desktopViewEnabled?: boolean;

	/**
	 * Custom Code is raw markup injected into every page of the suite (head/body). Applies flow-wide.
	 *
	 * @generated from field: optional bundles.v1.CustomCode custom_code = 31;
	 */
	customCode?: CustomCodeJson;

	/**
	 * Default Presentation Mode is the flow-level default applied to newly created pages in the flow.
	 *
	 * @generated from field: bundles.v1.PresentationMode default_presentation_mode = 32;
	 */
	defaultPresentationMode?: PresentationModeJson;

	/**
	 * Created At is the timestamp when the suite was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: TimestampJson;

	/**
	 * Updated At is the timestamp when the suite was last updated.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: TimestampJson;

	/**
	 * Archived At is the timestamp when the suite was archived. This is only relevant if the state field is set to archived.
	 *
	 * @generated from field: google.protobuf.Timestamp archived_at = 20;
	 */
	archivedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Suite.
 * Use `create(SuiteSchema)` to create a new message.
 */
export const SuiteSchema: GenMessage<Suite, { jsonType: SuiteJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 47);

/**
 * @generated from message bundles.v1.UserConversionSummary
 */
export type UserConversionSummary = Message<"bundles.v1.UserConversionSummary"> & {
	/**
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: int64 conversion_count = 2;
	 */
	conversionCount: bigint;

	/**
	 * @generated from field: int64 distinct_conversion_count = 5;
	 */
	distinctConversionCount: bigint;

	/**
	 * @generated from field: double ltv = 6;
	 */
	ltv: number;

	/**
	 * @generated from field: google.protobuf.Timestamp first_converted_at = 3;
	 */
	firstConvertedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp last_converted_at = 4;
	 */
	lastConvertedAt?: Timestamp | undefined;
};

/**
 * @generated from message bundles.v1.UserConversionSummary
 */
export type UserConversionSummaryJson = {
	/**
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * @generated from field: int64 conversion_count = 2;
	 */
	conversionCount?: string;

	/**
	 * @generated from field: int64 distinct_conversion_count = 5;
	 */
	distinctConversionCount?: string;

	/**
	 * @generated from field: double ltv = 6;
	 */
	ltv?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: google.protobuf.Timestamp first_converted_at = 3;
	 */
	firstConvertedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp last_converted_at = 4;
	 */
	lastConvertedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.UserConversionSummary.
 * Use `create(UserConversionSummarySchema)` to create a new message.
 */
export const UserConversionSummarySchema: GenMessage<UserConversionSummary, { jsonType: UserConversionSummaryJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 48);

/**
 * User is a message that represents a user in the system.
 *
 * @generated from message bundles.v1.User
 */
export type User = Message<"bundles.v1.User"> & {
	/**
	 * A GUID of the user
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string flow_id = 6;
	 */
	flowId: string;

	/**
	 * @generated from field: string primary_key = 7;
	 */
	primaryKey: string;

	/**
	 * @generated from field: string primary_id = 8;
	 */
	primaryId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string phone = 5;
	 */
	phone: string;
};

/**
 * User is a message that represents a user in the system.
 *
 * @generated from message bundles.v1.User
 */
export type UserJson = {
	/**
	 * A GUID of the user
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string flow_id = 6;
	 */
	flowId?: string;

	/**
	 * @generated from field: string primary_key = 7;
	 */
	primaryKey?: string;

	/**
	 * @generated from field: string primary_id = 8;
	 */
	primaryId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string phone = 5;
	 */
	phone?: string;
};

/**
 * Describes the message bundles.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User, { jsonType: UserJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 49);

/**
 * Event is a message that is fired when a user interacts with a suite.
 *
 * @generated from message bundles.v1.Event
 */
export type Event = Message<"bundles.v1.Event"> & {
	/**
	 * The user that fired the event
	 *
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * The suite that the user interacted with
	 *
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * The org that the user interacted with
	 *
	 * @generated from field: string org_id = 23;
	 */
	orgId: string;

	/**
	 * The workspace that the user interacted with
	 *
	 * @generated from field: string workspace_id = 15;
	 */
	workspaceId: string;

	/**
	 * The entrypoint that the user interacted with
	 *
	 * @generated from field: string entry_id = 16;
	 */
	entryId: string;

	/**
	 * The name of the entrypoint that the user interacted with
	 *
	 * @generated from field: string entry_name = 17;
	 */
	entryName: string;

	/**
	 * The key of the aset that the user interacted with
	 *
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * The type of event that was fired
	 *
	 * @generated from field: string event_type = 4;
	 */
	eventType: string;

	/**
	 * The type of conversion that was triggered
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType: ConversionType;

	/**
	 * The specific conversion component
	 *
	 * @generated from field: string conversion_component = 6;
	 */
	conversionComponent: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 9;
	 */
	photoUrl: string;

	/**
	 * @generated from field: bundles.v1.GeoLocation location = 10;
	 */
	location?: GeoLocation | undefined;

	/**
	 * @generated from field: bundles.v1.DeviceType device_type = 11;
	 */
	deviceType: DeviceType;

	/**
	 * @generated from field: google.protobuf.Struct request_data = 12;
	 */
	requestData?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct response_data = 13;
	 */
	responseData?: JsonObject | undefined;

	/**
	 * @generated from field: string integration_id = 18;
	 */
	integrationId: string;

	/**
	 * @generated from field: string integration_name = 19;
	 */
	integrationName: string;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 20;
	 */
	contactProperties: { [key: string]: Value };

	/**
	 * @generated from field: google.protobuf.Struct data_properties = 21;
	 */
	dataProperties?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct calendar_event_properties = 22;
	 */
	calendarEventProperties?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: Timestamp | undefined;
};

/**
 * Event is a message that is fired when a user interacts with a suite.
 *
 * @generated from message bundles.v1.Event
 */
export type EventJson = {
	/**
	 * The user that fired the event
	 *
	 * @generated from field: bundles.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * The suite that the user interacted with
	 *
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * The org that the user interacted with
	 *
	 * @generated from field: string org_id = 23;
	 */
	orgId?: string;

	/**
	 * The workspace that the user interacted with
	 *
	 * @generated from field: string workspace_id = 15;
	 */
	workspaceId?: string;

	/**
	 * The entrypoint that the user interacted with
	 *
	 * @generated from field: string entry_id = 16;
	 */
	entryId?: string;

	/**
	 * The name of the entrypoint that the user interacted with
	 *
	 * @generated from field: string entry_name = 17;
	 */
	entryName?: string;

	/**
	 * The key of the aset that the user interacted with
	 *
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * The type of event that was fired
	 *
	 * @generated from field: string event_type = 4;
	 */
	eventType?: string;

	/**
	 * The type of conversion that was triggered
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 5;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * The specific conversion component
	 *
	 * @generated from field: string conversion_component = 6;
	 */
	conversionComponent?: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 9;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: bundles.v1.GeoLocation location = 10;
	 */
	location?: GeoLocationJson;

	/**
	 * @generated from field: bundles.v1.DeviceType device_type = 11;
	 */
	deviceType?: DeviceTypeJson;

	/**
	 * @generated from field: google.protobuf.Struct request_data = 12;
	 */
	requestData?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct response_data = 13;
	 */
	responseData?: StructJson;

	/**
	 * @generated from field: string integration_id = 18;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string integration_name = 19;
	 */
	integrationName?: string;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 20;
	 */
	contactProperties?: { [key: string]: ValueJson };

	/**
	 * @generated from field: google.protobuf.Struct data_properties = 21;
	 */
	dataProperties?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct calendar_event_properties = 22;
	 */
	calendarEventProperties?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event, { jsonType: EventJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_bundle, 50);

/**
 * AssetType is an enumeration used to specify the type of asset contained in either a TemplateRef or an AssetRef
 *
 * @generated from enum bundles.v1.AssetType
 */
export enum AssetType {
	/**
	 * Undefined as the 0 value is a standard protobuf practice and this value should never be used.
	 *
	 * @generated from enum value: ASSET_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Deprecated. Placement corresponds to a design huddle template.
	 *
	 * @generated from enum value: ASSET_TYPE_PLACEMENT = 1;
	 */
	PLACEMENT = 1,

	/**
	 * Deprecated. Use ASSET_TYPE_CODE_V3
	 *
	 * @generated from enum value: ASSET_TYPE_CODE = 2;
	 */
	CODE = 2,

	/**
	 * Deprecated. Corresponds to Flowpages in F1
	 *
	 * @generated from enum value: ASSET_TYPE_PAGE = 3;
	 */
	PAGE = 3,

	/**
	 * Used to specify a Pages V2 Conversion Page
	 *
	 * @generated from enum value: ASSET_TYPE_PAGE_V2 = 4;
	 */
	PAGE_V2 = 4,

	/**
	 * The current standard asset type for a single code in F2
	 *
	 * @generated from enum value: ASSET_TYPE_CODE_V3 = 5;
	 */
	CODE_V3 = 5,

	/**
	 * An asset resprensent a group of CODE_V3 objects. Used for personalization templating. All codes in a batch must be related to the current suite.
	 *
	 * @generated from enum value: ASSET_TYPE_CODE_BATCH = 6;
	 */
	CODE_BATCH = 6,

	/**
	 * Landing Page is a specific type of asset for defining the default 'landing page' of a conversion flow.
	 *
	 * @generated from enum value: ASSET_TYPE_LANDING_PAGE = 7;
	 */
	LANDING_PAGE = 7,

	/**
	 * External Destination is used for specifying any type of URI which can be interpreted by a phone (URL, Deeplink, SMS, Phone) that will lead the user outside the conversion flow
	 *
	 * @generated from enum value: ASSET_TYPE_EXTERNAL_DESTINATION = 8;
	 */
	EXTERNAL_DESTINATION = 8,

	/**
	 * Experiment is used to a define a multi-arm bandit experiment
	 *
	 * @generated from enum value: ASSET_TYPE_EXPERIMENT = 9;
	 */
	EXPERIMENT = 9,

	/**
	 * Used to specify a wallet pass
	 *
	 * @generated from enum value: ASSET_TYPE_WALLET_PASS = 10;
	 */
	WALLET_PASS = 10,

	/**
	 * Represents a group of wallet passes
	 *
	 * @generated from enum value: ASSET_TYPE_WALLET_PASS_BATCH = 11;
	 */
	WALLET_PASS_BATCH = 11,

	/**
	 * Used to specify a short url
	 *
	 * @generated from enum value: ASSET_TYPE_SHORT_URL = 12;
	 */
	SHORT_URL = 12,

	/**
	 * An exit asset that ends the flow
	 *
	 * @generated from enum value: ASSET_TYPE_EXIT = 13;
	 */
	EXIT = 13,

	/**
	 * Represents a reusable module
	 *
	 * @generated from enum value: ASSET_TYPE_MODULE = 14;
	 */
	MODULE = 14,

	/**
	 * polymorphic batch type
	 *
	 * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH = 15;
	 */
	ENTRYPOINT_BATCH = 15,

	/**
	 * polymorphic batch type reference
	 *
	 * @generated from enum value: ASSET_TYPE_ENTRYPOINT_BATCH_REF = 19;
	 */
	ENTRYPOINT_BATCH_REF = 19,

	/**
	 * a decison ghost node
	 *
	 * @generated from enum value: ASSET_TYPE_DECISION = 16;
	 */
	DECISION = 16,

	/**
	 * a page container
	 *
	 * @generated from enum value: ASSET_TYPE_PAGE_CONTAINER = 17;
	 */
	PAGE_CONTAINER = 17,

	/**
	 * a reference to a suite object
	 *
	 * @generated from enum value: ASSET_TYPE_SUITE_REF = 18;
	 */
	SUITE_REF = 18,

	/**
	 * a static asset
	 *
	 * @generated from enum value: ASSET_TYPE_STATIC_ASSET = 20;
	 */
	STATIC_ASSET = 20,

	/**
	 * a terms and conditions policy asset ref
	 *
	 * @generated from enum value: ASSET_TYPE_POLICY_REF = 21;
	 */
	POLICY_REF = 21,

	/**
	 * a terms and conditions policy asset
	 *
	 * @generated from enum value: ASSET_TYPE_POLICY = 22;
	 */
	POLICY = 22,

	/**
	 * an AI agent connection
	 *
	 * @generated from enum value: ASSET_TYPE_AGENT = 23;
	 */
	AGENT = 23,

	/**
	 * a reference to a static asset
	 *
	 * @generated from enum value: ASSET_TYPE_STATIC_ASSET_REF = 24;
	 */
	STATIC_ASSET_REF = 24,

	/**
	 * a reference to a lookup object
	 *
	 * @generated from enum value: ASSET_TYPE_LOOKUP = 25;
	 */
	LOOKUP = 25,

	/**
	 * a reference to an ad unit asset
	 *
	 * @generated from enum value: ASSET_TYPE_AD_UNIT = 26;
	 */
	AD_UNIT = 26,

	/**
	 * a goto node
	 *
	 * @generated from enum value: ASSET_TYPE_GOTO = 27;
	 */
	GOTO = 27,
}

/**
 * AssetType is an enumeration used to specify the type of asset contained in either a TemplateRef or an AssetRef
 *
 * @generated from enum bundles.v1.AssetType
 */
export type AssetTypeJson =
	| "ASSET_TYPE_UNSPECIFIED"
	| "ASSET_TYPE_PLACEMENT"
	| "ASSET_TYPE_CODE"
	| "ASSET_TYPE_PAGE"
	| "ASSET_TYPE_PAGE_V2"
	| "ASSET_TYPE_CODE_V3"
	| "ASSET_TYPE_CODE_BATCH"
	| "ASSET_TYPE_LANDING_PAGE"
	| "ASSET_TYPE_EXTERNAL_DESTINATION"
	| "ASSET_TYPE_EXPERIMENT"
	| "ASSET_TYPE_WALLET_PASS"
	| "ASSET_TYPE_WALLET_PASS_BATCH"
	| "ASSET_TYPE_SHORT_URL"
	| "ASSET_TYPE_EXIT"
	| "ASSET_TYPE_MODULE"
	| "ASSET_TYPE_ENTRYPOINT_BATCH"
	| "ASSET_TYPE_ENTRYPOINT_BATCH_REF"
	| "ASSET_TYPE_DECISION"
	| "ASSET_TYPE_PAGE_CONTAINER"
	| "ASSET_TYPE_SUITE_REF"
	| "ASSET_TYPE_STATIC_ASSET"
	| "ASSET_TYPE_POLICY_REF"
	| "ASSET_TYPE_POLICY"
	| "ASSET_TYPE_AGENT"
	| "ASSET_TYPE_STATIC_ASSET_REF"
	| "ASSET_TYPE_LOOKUP"
	| "ASSET_TYPE_AD_UNIT"
	| "ASSET_TYPE_GOTO";

/**
 * Describes the enum bundles.v1.AssetType.
 */
export const AssetTypeSchema: GenEnum<AssetType, AssetTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 0);

/**
 * RenderMode is an enumeration used to specify how an asset should be rendered in a suite.
 *
 * @generated from enum bundles.v1.RenderMode
 */
export enum RenderMode {
	/**
	 * @generated from enum value: RENDER_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: RENDER_MODE_INLINE = 1;
	 */
	INLINE = 1,

	/**
	 * @generated from enum value: RENDER_MODE_MODAL = 2;
	 */
	MODAL = 2,

	/**
	 * @generated from enum value: RENDER_MODE_THUMBNAIL = 3;
	 */
	THUMBNAIL = 3,

	/**
	 * @generated from enum value: RENDER_MODE_IMAGE = 4;
	 */
	IMAGE = 4,
}

/**
 * RenderMode is an enumeration used to specify how an asset should be rendered in a suite.
 *
 * @generated from enum bundles.v1.RenderMode
 */
export type RenderModeJson = "RENDER_MODE_UNSPECIFIED" | "RENDER_MODE_INLINE" | "RENDER_MODE_MODAL" | "RENDER_MODE_THUMBNAIL" | "RENDER_MODE_IMAGE";

/**
 * Describes the enum bundles.v1.RenderMode.
 */
export const RenderModeSchema: GenEnum<RenderMode, RenderModeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 1);

/**
 * PresentationMode is an enumeration used to specify how pages should be presented in the flow.
 *
 * @generated from enum bundles.v1.PresentationMode
 */
export enum PresentationMode {
	/**
	 * @generated from enum value: PRESENTATION_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PRESENTATION_MODE_PAGE = 1;
	 */
	PAGE = 1,

	/**
	 * @generated from enum value: PRESENTATION_MODE_TRAY = 2;
	 */
	TRAY = 2,
}

/**
 * PresentationMode is an enumeration used to specify how pages should be presented in the flow.
 *
 * @generated from enum bundles.v1.PresentationMode
 */
export type PresentationModeJson = "PRESENTATION_MODE_UNSPECIFIED" | "PRESENTATION_MODE_PAGE" | "PRESENTATION_MODE_TRAY";

/**
 * Describes the enum bundles.v1.PresentationMode.
 */
export const PresentationModeSchema: GenEnum<PresentationMode, PresentationModeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 2);

/**
 * ExternalDestinationType is the type of external destination.
 *
 * @generated from enum bundles.v1.ExternalDestinationType
 */
export enum ExternalDestinationType {
	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_URL = 1;
	 */
	URL = 1,

	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_EMAIL = 2;
	 */
	EMAIL = 2,

	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_SMS = 3;
	 */
	SMS = 3,

	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_PHONE = 4;
	 */
	PHONE = 4,

	/**
	 * @generated from enum value: EXTERNAL_DESTINATION_TYPE_DEEPLINK = 5;
	 */
	DEEPLINK = 5,
}

/**
 * ExternalDestinationType is the type of external destination.
 *
 * @generated from enum bundles.v1.ExternalDestinationType
 */
export type ExternalDestinationTypeJson = "EXTERNAL_DESTINATION_TYPE_UNSPECIFIED" | "EXTERNAL_DESTINATION_TYPE_URL" | "EXTERNAL_DESTINATION_TYPE_EMAIL" | "EXTERNAL_DESTINATION_TYPE_SMS" | "EXTERNAL_DESTINATION_TYPE_PHONE" | "EXTERNAL_DESTINATION_TYPE_DEEPLINK";

/**
 * Describes the enum bundles.v1.ExternalDestinationType.
 */
export const ExternalDestinationTypeSchema: GenEnum<ExternalDestinationType, ExternalDestinationTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 3);

/**
 * @generated from enum bundles.v1.ExperimentType
 */
export enum ExperimentType {
	/**
	 * @generated from enum value: EXPERIMENT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EXPERIMENT_TYPE_BANDIT = 1;
	 */
	BANDIT = 1,
}

/**
 * @generated from enum bundles.v1.ExperimentType
 */
export type ExperimentTypeJson = "EXPERIMENT_TYPE_UNSPECIFIED" | "EXPERIMENT_TYPE_BANDIT";

/**
 * Describes the enum bundles.v1.ExperimentType.
 */
export const ExperimentTypeSchema: GenEnum<ExperimentType, ExperimentTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 4);

/**
 * @generated from enum bundles.v1.HttpMethod
 */
export enum HttpMethod {
	/**
	 * @generated from enum value: HTTP_METHOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: HTTP_METHOD_GET = 1;
	 */
	GET = 1,

	/**
	 * @generated from enum value: HTTP_METHOD_POST = 2;
	 */
	POST = 2,

	/**
	 * @generated from enum value: HTTP_METHOD_PUT = 3;
	 */
	PUT = 3,

	/**
	 * @generated from enum value: HTTP_METHOD_DELETE = 4;
	 */
	DELETE = 4,

	/**
	 * @generated from enum value: HTTP_METHOD_PATCH = 5;
	 */
	PATCH = 5,
}

/**
 * @generated from enum bundles.v1.HttpMethod
 */
export type HttpMethodJson = "HTTP_METHOD_UNSPECIFIED" | "HTTP_METHOD_GET" | "HTTP_METHOD_POST" | "HTTP_METHOD_PUT" | "HTTP_METHOD_DELETE" | "HTTP_METHOD_PATCH";

/**
 * Describes the enum bundles.v1.HttpMethod.
 */
export const HttpMethodSchema: GenEnum<HttpMethod, HttpMethodJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 5);

/**
 * @generated from enum bundles.v1.AuthType
 */
export enum AuthType {
	/**
	 * @generated from enum value: AUTH_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: AUTH_TYPE_BASIC = 1;
	 */
	BASIC = 1,

	/**
	 * @generated from enum value: AUTH_TYPE_BEARER = 2;
	 */
	BEARER = 2,

	/**
	 * @generated from enum value: AUTH_TYPE_API_KEY = 3;
	 */
	API_KEY = 3,
}

/**
 * @generated from enum bundles.v1.AuthType
 */
export type AuthTypeJson = "AUTH_TYPE_UNSPECIFIED" | "AUTH_TYPE_BASIC" | "AUTH_TYPE_BEARER" | "AUTH_TYPE_API_KEY";

/**
 * Describes the enum bundles.v1.AuthType.
 */
export const AuthTypeSchema: GenEnum<AuthType, AuthTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 6);

/**
 * @generated from enum bundles.v1.ApiKeyLocation
 */
export enum ApiKeyLocation {
	/**
	 * @generated from enum value: API_KEY_LOCATION_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: API_KEY_LOCATION_QUERY = 1;
	 */
	QUERY = 1,

	/**
	 * @generated from enum value: API_KEY_LOCATION_HEADER = 2;
	 */
	HEADER = 2,
}

/**
 * @generated from enum bundles.v1.ApiKeyLocation
 */
export type ApiKeyLocationJson = "API_KEY_LOCATION_UNSPECIFIED" | "API_KEY_LOCATION_QUERY" | "API_KEY_LOCATION_HEADER";

/**
 * Describes the enum bundles.v1.ApiKeyLocation.
 */
export const ApiKeyLocationSchema: GenEnum<ApiKeyLocation, ApiKeyLocationJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 7);

/**
 * @generated from enum bundles.v1.ConversionType
 */
export enum ConversionType {
	/**
	 * @generated from enum value: CONVERSION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CONVERSION_TYPE_NONE = 4;
	 */
	NONE = 4,

	/**
	 * @generated from enum value: CONVERSION_TYPE_CONTACT_COLLECTION = 1;
	 */
	CONTACT_COLLECTION = 1,

	/**
	 * @generated from enum value: CONVERSION_TYPE_CONTACT_DOWNLOADED = 6;
	 */
	CONTACT_DOWNLOADED = 6,

	/**
	 * @generated from enum value: CONVERSION_TYPE_PURCHASE = 2;
	 */
	PURCHASE = 2,

	/**
	 * @generated from enum value: CONVERSION_TYPE_FORM_SUBMISSION = 3;
	 */
	FORM_SUBMISSION = 3,

	/**
	 * @generated from enum value: CONVERSION_TYPE_EXTERNAL_PIXEL = 5;
	 */
	EXTERNAL_PIXEL = 5,

	/**
	 * @generated from enum value: CONVERSION_TYPE_FILE_DOWNLOADED = 7;
	 */
	FILE_DOWNLOADED = 7,

	/**
	 * @generated from enum value: CONVERSION_TYPE_POLL_COMPLETED = 8;
	 */
	POLL_COMPLETED = 8,
}

/**
 * @generated from enum bundles.v1.ConversionType
 */
export type ConversionTypeJson = "CONVERSION_TYPE_UNSPECIFIED" | "CONVERSION_TYPE_NONE" | "CONVERSION_TYPE_CONTACT_COLLECTION" | "CONVERSION_TYPE_CONTACT_DOWNLOADED" | "CONVERSION_TYPE_PURCHASE" | "CONVERSION_TYPE_FORM_SUBMISSION" | "CONVERSION_TYPE_EXTERNAL_PIXEL" | "CONVERSION_TYPE_FILE_DOWNLOADED" | "CONVERSION_TYPE_POLL_COMPLETED";

/**
 * Describes the enum bundles.v1.ConversionType.
 */
export const ConversionTypeSchema: GenEnum<ConversionType, ConversionTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 8);

/**
 * @generated from enum bundles.v1.ConversionSource
 */
export enum ConversionSource {
	/**
	 * @generated from enum value: CONVERSION_SOURCE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CONVERSION_SOURCE_INTERNAL = 1;
	 */
	INTERNAL = 1,

	/**
	 * @generated from enum value: CONVERSION_SOURCE_EXTERNAL_PRODUCT = 2;
	 */
	EXTERNAL_PRODUCT = 2,

	/**
	 * @generated from enum value: CONVERSION_SOURCE_EXTERNAL_PIXEL = 3;
	 */
	EXTERNAL_PIXEL = 3,
}

/**
 * @generated from enum bundles.v1.ConversionSource
 */
export type ConversionSourceJson = "CONVERSION_SOURCE_UNSPECIFIED" | "CONVERSION_SOURCE_INTERNAL" | "CONVERSION_SOURCE_EXTERNAL_PRODUCT" | "CONVERSION_SOURCE_EXTERNAL_PIXEL";

/**
 * Describes the enum bundles.v1.ConversionSource.
 */
export const ConversionSourceSchema: GenEnum<ConversionSource, ConversionSourceJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 9);

/**
 * BundleType is an enumeration used to specify the type of bundle that is being created.
 *
 * @generated from enum bundles.v1.BundleType
 */
export enum BundleType {
	/**
	 * Unspecified is the 0 value is a standard protobuf practice and this value should never be used.
	 *
	 * @generated from enum value: BUNDLE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Custom is a bundle type that is created from scratch.
	 *
	 * @generated from enum value: BUNDLE_TYPE_CUSTOM = 1;
	 */
	CUSTOM = 1,

	/**
	 * Real Estate is a bundle type that is created for real estate listings.
	 *
	 * @generated from enum value: BUNDLE_TYPE_REAL_ESTATE = 2;
	 */
	REAL_ESTATE = 2,

	/**
	 * Commerce is a bundle type that is created for commerce products.
	 *
	 * @generated from enum value: BUNDLE_TYPE_COMMERCE = 3;
	 */
	COMMERCE = 3,

	/**
	 * Form is a bundle type that is created for general form submissions.
	 *
	 * @generated from enum value: BUNDLE_TYPE_FORM = 4;
	 */
	FORM = 4,

	/**
	 * External is a bundle type that is created for external destinations.
	 *
	 * @generated from enum value: BUNDLE_TYPE_EXTERNAL = 5;
	 */
	EXTERNAL = 5,

	/**
	 * Contact is a bundle type that is created for contact sharing.
	 *
	 * @generated from enum value: BUNDLE_TYPE_CONTACT = 6;
	 */
	CONTACT = 6,
}

/**
 * BundleType is an enumeration used to specify the type of bundle that is being created.
 *
 * @generated from enum bundles.v1.BundleType
 */
export type BundleTypeJson = "BUNDLE_TYPE_UNSPECIFIED" | "BUNDLE_TYPE_CUSTOM" | "BUNDLE_TYPE_REAL_ESTATE" | "BUNDLE_TYPE_COMMERCE" | "BUNDLE_TYPE_FORM" | "BUNDLE_TYPE_EXTERNAL" | "BUNDLE_TYPE_CONTACT";

/**
 * Describes the enum bundles.v1.BundleType.
 */
export const BundleTypeSchema: GenEnum<BundleType, BundleTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 10);

/**
 * ResponseType is the type of model response
 *
 * @generated from enum bundles.v1.ResponseType
 */
export enum ResponseType {
	/**
	 * @generated from enum value: RESPONSE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: RESPONSE_TYPE_TEXT = 1;
	 */
	TEXT = 1,

	/**
	 * @generated from enum value: RESPONSE_TYPE_IMAGE = 2;
	 */
	IMAGE = 2,

	/**
	 * @generated from enum value: RESPONSE_TYPE_AUDIO = 3;
	 */
	AUDIO = 3,
}

/**
 * ResponseType is the type of model response
 *
 * @generated from enum bundles.v1.ResponseType
 */
export type ResponseTypeJson = "RESPONSE_TYPE_UNSPECIFIED" | "RESPONSE_TYPE_TEXT" | "RESPONSE_TYPE_IMAGE" | "RESPONSE_TYPE_AUDIO";

/**
 * Describes the enum bundles.v1.ResponseType.
 */
export const ResponseTypeSchema: GenEnum<ResponseType, ResponseTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_bundle, 11);
